// This Source Code Form is subject to the terms of the Mozilla Public
// License, v2.0. If a copy of the MPL was not distributed with this
// file, You can obtain one at http://mozilla.org/MPL/2.0/

const ros1Definitions = {
  "actionlib_msgs/GoalStatusArray": {
    name: "actionlib_msgs/GoalStatusArray",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "actionlib_msgs/GoalStatus", isArray: true, name: "status_list", isComplex: true },
    ],
  },
  "std_msgs/Header": {
    name: "std_msgs/Header",
    definitions: [
      { type: "uint32", isArray: false, name: "seq", isComplex: false },
      { type: "time", isArray: false, name: "stamp", isComplex: false },
      { type: "string", isArray: false, name: "frame_id", isComplex: false },
    ],
  },
  "actionlib_msgs/GoalStatus": {
    name: "actionlib_msgs/GoalStatus",
    definitions: [
      { type: "actionlib_msgs/GoalID", isArray: false, name: "goal_id", isComplex: true },
      { type: "uint8", isArray: false, name: "status", isComplex: false },
      { type: "uint8", name: "PENDING", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "ACTIVE", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "PREEMPTED", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "SUCCEEDED", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", name: "ABORTED", isConstant: true, value: 4, valueText: "4" },
      { type: "uint8", name: "REJECTED", isConstant: true, value: 5, valueText: "5" },
      { type: "uint8", name: "PREEMPTING", isConstant: true, value: 6, valueText: "6" },
      { type: "uint8", name: "RECALLING", isConstant: true, value: 7, valueText: "7" },
      { type: "uint8", name: "RECALLED", isConstant: true, value: 8, valueText: "8" },
      { type: "uint8", name: "LOST", isConstant: true, value: 9, valueText: "9" },
      { type: "string", isArray: false, name: "text", isComplex: false },
    ],
  },
  "actionlib_msgs/GoalID": {
    name: "actionlib_msgs/GoalID",
    definitions: [
      { type: "time", isArray: false, name: "stamp", isComplex: false },
      { type: "string", isArray: false, name: "id", isComplex: false },
    ],
  },
  "diagnostic_msgs/DiagnosticArray": {
    name: "diagnostic_msgs/DiagnosticArray",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "diagnostic_msgs/DiagnosticStatus", isArray: true, name: "status", isComplex: true },
    ],
  },
  "diagnostic_msgs/DiagnosticStatus": {
    name: "diagnostic_msgs/DiagnosticStatus",
    definitions: [
      { type: "int8", name: "OK", isConstant: true, value: 0, valueText: "0" },
      { type: "int8", name: "WARN", isConstant: true, value: 1, valueText: "1" },
      { type: "int8", name: "ERROR", isConstant: true, value: 2, valueText: "2" },
      { type: "int8", name: "STALE", isConstant: true, value: 3, valueText: "3" },
      { type: "int8", isArray: false, name: "level", isComplex: false },
      { type: "string", isArray: false, name: "name", isComplex: false },
      { type: "string", isArray: false, name: "message", isComplex: false },
      { type: "string", isArray: false, name: "hardware_id", isComplex: false },
      { type: "diagnostic_msgs/KeyValue", isArray: true, name: "values", isComplex: true },
    ],
  },
  "diagnostic_msgs/KeyValue": {
    name: "diagnostic_msgs/KeyValue",
    definitions: [
      { type: "string", isArray: false, name: "key", isComplex: false },
      { type: "string", isArray: false, name: "value", isComplex: false },
    ],
  },
  "geometry_msgs/AccelStamped": {
    name: "geometry_msgs/AccelStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Accel", isArray: false, name: "accel", isComplex: true },
    ],
  },
  "geometry_msgs/Accel": {
    name: "geometry_msgs/Accel",
    definitions: [
      { type: "geometry_msgs/Vector3", isArray: false, name: "linear", isComplex: true },
      { type: "geometry_msgs/Vector3", isArray: false, name: "angular", isComplex: true },
    ],
  },
  "geometry_msgs/Vector3": {
    name: "geometry_msgs/Vector3",
    definitions: [
      { type: "float64", isArray: false, name: "x", isComplex: false },
      { type: "float64", isArray: false, name: "y", isComplex: false },
      { type: "float64", isArray: false, name: "z", isComplex: false },
    ],
  },
  "geometry_msgs/AccelWithCovarianceStamped": {
    name: "geometry_msgs/AccelWithCovarianceStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/AccelWithCovariance", isArray: false, name: "accel", isComplex: true },
    ],
  },
  "geometry_msgs/AccelWithCovariance": {
    name: "geometry_msgs/AccelWithCovariance",
    definitions: [
      { type: "geometry_msgs/Accel", isArray: false, name: "accel", isComplex: true },
      { type: "float64", isArray: true, arrayLength: 36, name: "covariance", isComplex: false },
    ],
  },
  "geometry_msgs/InertiaStamped": {
    name: "geometry_msgs/InertiaStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Inertia", isArray: false, name: "inertia", isComplex: true },
    ],
  },
  "geometry_msgs/Inertia": {
    name: "geometry_msgs/Inertia",
    definitions: [
      { type: "float64", isArray: false, name: "m", isComplex: false },
      { type: "geometry_msgs/Vector3", isArray: false, name: "com", isComplex: true },
      { type: "float64", isArray: false, name: "ixx", isComplex: false },
      { type: "float64", isArray: false, name: "ixy", isComplex: false },
      { type: "float64", isArray: false, name: "ixz", isComplex: false },
      { type: "float64", isArray: false, name: "iyy", isComplex: false },
      { type: "float64", isArray: false, name: "iyz", isComplex: false },
      { type: "float64", isArray: false, name: "izz", isComplex: false },
    ],
  },
  "geometry_msgs/Point32": {
    name: "geometry_msgs/Point32",
    definitions: [
      { type: "float32", isArray: false, name: "x", isComplex: false },
      { type: "float32", isArray: false, name: "y", isComplex: false },
      { type: "float32", isArray: false, name: "z", isComplex: false },
    ],
  },
  "geometry_msgs/PointStamped": {
    name: "geometry_msgs/PointStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Point", isArray: false, name: "point", isComplex: true },
    ],
  },
  "geometry_msgs/Point": {
    name: "geometry_msgs/Point",
    definitions: [
      { type: "float64", isArray: false, name: "x", isComplex: false },
      { type: "float64", isArray: false, name: "y", isComplex: false },
      { type: "float64", isArray: false, name: "z", isComplex: false },
    ],
  },
  "geometry_msgs/PolygonStamped": {
    name: "geometry_msgs/PolygonStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Polygon", isArray: false, name: "polygon", isComplex: true },
    ],
  },
  "geometry_msgs/Polygon": {
    name: "geometry_msgs/Polygon",
    definitions: [
      { type: "geometry_msgs/Point32", isArray: true, name: "points", isComplex: true },
    ],
  },
  "geometry_msgs/PoseArray": {
    name: "geometry_msgs/PoseArray",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Pose", isArray: true, name: "poses", isComplex: true },
    ],
  },
  "geometry_msgs/Pose": {
    name: "geometry_msgs/Pose",
    definitions: [
      { type: "geometry_msgs/Point", isArray: false, name: "position", isComplex: true },
      { type: "geometry_msgs/Quaternion", isArray: false, name: "orientation", isComplex: true },
    ],
  },
  "geometry_msgs/Quaternion": {
    name: "geometry_msgs/Quaternion",
    definitions: [
      { type: "float64", isArray: false, name: "x", isComplex: false },
      { type: "float64", isArray: false, name: "y", isComplex: false },
      { type: "float64", isArray: false, name: "z", isComplex: false },
      { type: "float64", isArray: false, name: "w", isComplex: false },
    ],
  },
  "geometry_msgs/PoseStamped": {
    name: "geometry_msgs/PoseStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Pose", isArray: false, name: "pose", isComplex: true },
    ],
  },
  "geometry_msgs/PoseWithCovarianceStamped": {
    name: "geometry_msgs/PoseWithCovarianceStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/PoseWithCovariance", isArray: false, name: "pose", isComplex: true },
    ],
  },
  "geometry_msgs/PoseWithCovariance": {
    name: "geometry_msgs/PoseWithCovariance",
    definitions: [
      { type: "geometry_msgs/Pose", isArray: false, name: "pose", isComplex: true },
      { type: "float64", isArray: true, arrayLength: 36, name: "covariance", isComplex: false },
    ],
  },
  "geometry_msgs/QuaternionStamped": {
    name: "geometry_msgs/QuaternionStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Quaternion", isArray: false, name: "quaternion", isComplex: true },
    ],
  },
  "geometry_msgs/TransformStamped": {
    name: "geometry_msgs/TransformStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: false, name: "child_frame_id", isComplex: false },
      { type: "geometry_msgs/Transform", isArray: false, name: "transform", isComplex: true },
    ],
  },
  "geometry_msgs/Transform": {
    name: "geometry_msgs/Transform",
    definitions: [
      { type: "geometry_msgs/Vector3", isArray: false, name: "translation", isComplex: true },
      { type: "geometry_msgs/Quaternion", isArray: false, name: "rotation", isComplex: true },
    ],
  },
  "geometry_msgs/TwistStamped": {
    name: "geometry_msgs/TwistStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Twist", isArray: false, name: "twist", isComplex: true },
    ],
  },
  "geometry_msgs/Twist": {
    name: "geometry_msgs/Twist",
    definitions: [
      { type: "geometry_msgs/Vector3", isArray: false, name: "linear", isComplex: true },
      { type: "geometry_msgs/Vector3", isArray: false, name: "angular", isComplex: true },
    ],
  },
  "geometry_msgs/TwistWithCovarianceStamped": {
    name: "geometry_msgs/TwistWithCovarianceStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/TwistWithCovariance", isArray: false, name: "twist", isComplex: true },
    ],
  },
  "geometry_msgs/TwistWithCovariance": {
    name: "geometry_msgs/TwistWithCovariance",
    definitions: [
      { type: "geometry_msgs/Twist", isArray: false, name: "twist", isComplex: true },
      { type: "float64", isArray: true, arrayLength: 36, name: "covariance", isComplex: false },
    ],
  },
  "geometry_msgs/Vector3Stamped": {
    name: "geometry_msgs/Vector3Stamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Vector3", isArray: false, name: "vector", isComplex: true },
    ],
  },
  "geometry_msgs/WrenchStamped": {
    name: "geometry_msgs/WrenchStamped",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Wrench", isArray: false, name: "wrench", isComplex: true },
    ],
  },
  "geometry_msgs/Wrench": {
    name: "geometry_msgs/Wrench",
    definitions: [
      { type: "geometry_msgs/Vector3", isArray: false, name: "force", isComplex: true },
      { type: "geometry_msgs/Vector3", isArray: false, name: "torque", isComplex: true },
    ],
  },
  "nav_msgs/OccupancyGrid": {
    name: "nav_msgs/OccupancyGrid",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "nav_msgs/MapMetaData", isArray: false, name: "info", isComplex: true },
      { type: "int8", isArray: true, name: "data", isComplex: false },
    ],
  },
  "nav_msgs/MapMetaData": {
    name: "nav_msgs/MapMetaData",
    definitions: [
      { type: "time", isArray: false, name: "map_load_time", isComplex: false },
      { type: "float32", isArray: false, name: "resolution", isComplex: false },
      { type: "uint32", isArray: false, name: "width", isComplex: false },
      { type: "uint32", isArray: false, name: "height", isComplex: false },
      { type: "geometry_msgs/Pose", isArray: false, name: "origin", isComplex: true },
    ],
  },
  "nav_msgs/Odometry": {
    name: "nav_msgs/Odometry",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: false, name: "child_frame_id", isComplex: false },
      { type: "geometry_msgs/PoseWithCovariance", isArray: false, name: "pose", isComplex: true },
      { type: "geometry_msgs/TwistWithCovariance", isArray: false, name: "twist", isComplex: true },
    ],
  },
  "nav_msgs/Path": {
    name: "nav_msgs/Path",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/PoseStamped", isArray: true, name: "poses", isComplex: true },
    ],
  },
  "rcl_interfaces/Log": {
    name: "rcl_interfaces/Log",
    definitions: [
      { type: "int8", name: "DEBUG", isConstant: true, value: 10, valueText: "10" },
      { type: "int8", name: "INFO", isConstant: true, value: 20, valueText: "20" },
      { type: "int8", name: "WARN", isConstant: true, value: 30, valueText: "30" },
      { type: "int8", name: "ERROR", isConstant: true, value: 40, valueText: "40" },
      { type: "int8", name: "FATAL", isConstant: true, value: 50, valueText: "50" },
      { type: "time", isArray: false, name: "stamp", isComplex: false },
      { type: "uint8", isArray: false, name: "level", isComplex: false },
      { type: "string", isArray: false, name: "name", isComplex: false },
      { type: "string", isArray: false, name: "msg", isComplex: false },
      { type: "string", isArray: false, name: "file", isComplex: false },
      { type: "string", isArray: false, name: "function", isComplex: false },
      { type: "uint32", isArray: false, name: "line", isComplex: false },
    ],
  },
  "rosgraph_msgs/Clock": {
    name: "rosgraph_msgs/Clock",
    definitions: [{ type: "time", isArray: false, name: "clock", isComplex: false }],
  },
  "rosgraph_msgs/Log": {
    name: "rosgraph_msgs/Log",
    definitions: [
      { type: "int8", name: "DEBUG", isConstant: true, value: 1, valueText: "1" },
      { type: "int8", name: "INFO", isConstant: true, value: 2, valueText: "2" },
      { type: "int8", name: "WARN", isConstant: true, value: 4, valueText: "4" },
      { type: "int8", name: "ERROR", isConstant: true, value: 8, valueText: "8" },
      { type: "int8", name: "FATAL", isConstant: true, value: 16, valueText: "16" },
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "int8", isArray: false, name: "level", isComplex: false },
      { type: "string", isArray: false, name: "name", isComplex: false },
      { type: "string", isArray: false, name: "msg", isComplex: false },
      { type: "string", isArray: false, name: "file", isComplex: false },
      { type: "string", isArray: false, name: "function", isComplex: false },
      { type: "uint32", isArray: false, name: "line", isComplex: false },
      { type: "string", isArray: true, name: "topics", isComplex: false },
    ],
  },
  "rosgraph_msgs/TopicStatistics": {
    name: "rosgraph_msgs/TopicStatistics",
    definitions: [
      { type: "string", isArray: false, name: "topic", isComplex: false },
      { type: "string", isArray: false, name: "node_pub", isComplex: false },
      { type: "string", isArray: false, name: "node_sub", isComplex: false },
      { type: "time", isArray: false, name: "window_start", isComplex: false },
      { type: "time", isArray: false, name: "window_stop", isComplex: false },
      { type: "int32", isArray: false, name: "delivered_msgs", isComplex: false },
      { type: "int32", isArray: false, name: "dropped_msgs", isComplex: false },
      { type: "int32", isArray: false, name: "traffic", isComplex: false },
      { type: "duration", isArray: false, name: "period_mean", isComplex: false },
      { type: "duration", isArray: false, name: "period_stddev", isComplex: false },
      { type: "duration", isArray: false, name: "period_max", isComplex: false },
      { type: "duration", isArray: false, name: "stamp_age_mean", isComplex: false },
      { type: "duration", isArray: false, name: "stamp_age_stddev", isComplex: false },
      { type: "duration", isArray: false, name: "stamp_age_max", isComplex: false },
    ],
  },
  "sensor_msgs/BatteryState": {
    name: "sensor_msgs/BatteryState",
    definitions: [
      {
        type: "uint8",
        name: "POWER_SUPPLY_STATUS_UNKNOWN",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_STATUS_CHARGING",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_STATUS_DISCHARGING",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_STATUS_NOT_CHARGING",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_STATUS_FULL",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_UNKNOWN",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_GOOD",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_OVERHEAT",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_DEAD",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_OVERVOLTAGE",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_UNSPEC_FAILURE",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_COLD",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE",
        isConstant: true,
        value: 8,
        valueText: "8",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_UNKNOWN",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_NIMH",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_LION",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_LIPO",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_LIFE",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_NICD",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        type: "uint8",
        name: "POWER_SUPPLY_TECHNOLOGY_LIMN",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float32", isArray: false, name: "voltage", isComplex: false },
      { type: "float32", isArray: false, name: "temperature", isComplex: false },
      { type: "float32", isArray: false, name: "current", isComplex: false },
      { type: "float32", isArray: false, name: "charge", isComplex: false },
      { type: "float32", isArray: false, name: "capacity", isComplex: false },
      { type: "float32", isArray: false, name: "design_capacity", isComplex: false },
      { type: "float32", isArray: false, name: "percentage", isComplex: false },
      { type: "uint8", isArray: false, name: "power_supply_status", isComplex: false },
      { type: "uint8", isArray: false, name: "power_supply_health", isComplex: false },
      { type: "uint8", isArray: false, name: "power_supply_technology", isComplex: false },
      { type: "bool", isArray: false, name: "present", isComplex: false },
      { type: "float32", isArray: true, name: "cell_voltage", isComplex: false },
      { type: "float32", isArray: true, name: "cell_temperature", isComplex: false },
      { type: "string", isArray: false, name: "location", isComplex: false },
      { type: "string", isArray: false, name: "serial_number", isComplex: false },
    ],
  },
  "sensor_msgs/CameraInfo": {
    name: "sensor_msgs/CameraInfo",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "uint32", isArray: false, name: "height", isComplex: false },
      { type: "uint32", isArray: false, name: "width", isComplex: false },
      { type: "string", isArray: false, name: "distortion_model", isComplex: false },
      { type: "float64", isArray: true, name: "D", isComplex: false },
      { type: "float64", isArray: true, arrayLength: 9, name: "K", isComplex: false },
      { type: "float64", isArray: true, arrayLength: 9, name: "R", isComplex: false },
      { type: "float64", isArray: true, arrayLength: 12, name: "P", isComplex: false },
      { type: "uint32", isArray: false, name: "binning_x", isComplex: false },
      { type: "uint32", isArray: false, name: "binning_y", isComplex: false },
      { type: "sensor_msgs/RegionOfInterest", isArray: false, name: "roi", isComplex: true },
    ],
  },
  "sensor_msgs/RegionOfInterest": {
    name: "sensor_msgs/RegionOfInterest",
    definitions: [
      { type: "uint32", isArray: false, name: "x_offset", isComplex: false },
      { type: "uint32", isArray: false, name: "y_offset", isComplex: false },
      { type: "uint32", isArray: false, name: "height", isComplex: false },
      { type: "uint32", isArray: false, name: "width", isComplex: false },
      { type: "bool", isArray: false, name: "do_rectify", isComplex: false },
    ],
  },
  "sensor_msgs/CompressedImage": {
    name: "sensor_msgs/CompressedImage",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: false, name: "format", isComplex: false },
      { type: "uint8", isArray: true, name: "data", isComplex: false },
    ],
  },
  "sensor_msgs/FluidPressure": {
    name: "sensor_msgs/FluidPressure",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float64", isArray: false, name: "fluid_pressure", isComplex: false },
      { type: "float64", isArray: false, name: "variance", isComplex: false },
    ],
  },
  "sensor_msgs/Illuminance": {
    name: "sensor_msgs/Illuminance",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float64", isArray: false, name: "illuminance", isComplex: false },
      { type: "float64", isArray: false, name: "variance", isComplex: false },
    ],
  },
  "sensor_msgs/Image": {
    name: "sensor_msgs/Image",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "uint32", isArray: false, name: "height", isComplex: false },
      { type: "uint32", isArray: false, name: "width", isComplex: false },
      { type: "string", isArray: false, name: "encoding", isComplex: false },
      { type: "uint8", isArray: false, name: "is_bigendian", isComplex: false },
      { type: "uint32", isArray: false, name: "step", isComplex: false },
      { type: "uint8", isArray: true, name: "data", isComplex: false },
    ],
  },
  "sensor_msgs/Imu": {
    name: "sensor_msgs/Imu",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Quaternion", isArray: false, name: "orientation", isComplex: true },
      {
        type: "float64",
        isArray: true,
        arrayLength: 9,
        name: "orientation_covariance",
        isComplex: false,
      },
      { type: "geometry_msgs/Vector3", isArray: false, name: "angular_velocity", isComplex: true },
      {
        type: "float64",
        isArray: true,
        arrayLength: 9,
        name: "angular_velocity_covariance",
        isComplex: false,
      },
      {
        type: "geometry_msgs/Vector3",
        isArray: false,
        name: "linear_acceleration",
        isComplex: true,
      },
      {
        type: "float64",
        isArray: true,
        arrayLength: 9,
        name: "linear_acceleration_covariance",
        isComplex: false,
      },
    ],
  },
  "sensor_msgs/JointState": {
    name: "sensor_msgs/JointState",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: true, name: "name", isComplex: false },
      { type: "float64", isArray: true, name: "position", isComplex: false },
      { type: "float64", isArray: true, name: "velocity", isComplex: false },
      { type: "float64", isArray: true, name: "effort", isComplex: false },
    ],
  },
  "sensor_msgs/Joy": {
    name: "sensor_msgs/Joy",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float32", isArray: true, name: "axes", isComplex: false },
      { type: "int32", isArray: true, name: "buttons", isComplex: false },
    ],
  },
  "sensor_msgs/JoyFeedbackArray": {
    name: "sensor_msgs/JoyFeedbackArray",
    definitions: [
      { type: "sensor_msgs/JoyFeedback", isArray: true, name: "array", isComplex: true },
    ],
  },
  "sensor_msgs/JoyFeedback": {
    name: "sensor_msgs/JoyFeedback",
    definitions: [
      { type: "uint8", name: "TYPE_LED", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "TYPE_RUMBLE", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "TYPE_BUZZER", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", isArray: false, name: "type", isComplex: false },
      { type: "uint8", isArray: false, name: "id", isComplex: false },
      { type: "float32", isArray: false, name: "intensity", isComplex: false },
    ],
  },
  "sensor_msgs/LaserScan": {
    name: "sensor_msgs/LaserScan",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float32", isArray: false, name: "angle_min", isComplex: false },
      { type: "float32", isArray: false, name: "angle_max", isComplex: false },
      { type: "float32", isArray: false, name: "angle_increment", isComplex: false },
      { type: "float32", isArray: false, name: "time_increment", isComplex: false },
      { type: "float32", isArray: false, name: "scan_time", isComplex: false },
      { type: "float32", isArray: false, name: "range_min", isComplex: false },
      { type: "float32", isArray: false, name: "range_max", isComplex: false },
      { type: "float32", isArray: true, name: "ranges", isComplex: false },
      { type: "float32", isArray: true, name: "intensities", isComplex: false },
    ],
  },
  "sensor_msgs/MagneticField": {
    name: "sensor_msgs/MagneticField",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Vector3", isArray: false, name: "magnetic_field", isComplex: true },
      {
        type: "float64",
        isArray: true,
        arrayLength: 9,
        name: "magnetic_field_covariance",
        isComplex: false,
      },
    ],
  },
  "sensor_msgs/MultiDOFJointState": {
    name: "sensor_msgs/MultiDOFJointState",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: true, name: "joint_names", isComplex: false },
      { type: "geometry_msgs/Transform", isArray: true, name: "transforms", isComplex: true },
      { type: "geometry_msgs/Twist", isArray: true, name: "twist", isComplex: true },
      { type: "geometry_msgs/Wrench", isArray: true, name: "wrench", isComplex: true },
    ],
  },
  "sensor_msgs/MultiEchoLaserScan": {
    name: "sensor_msgs/MultiEchoLaserScan",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float32", isArray: false, name: "angle_min", isComplex: false },
      { type: "float32", isArray: false, name: "angle_max", isComplex: false },
      { type: "float32", isArray: false, name: "angle_increment", isComplex: false },
      { type: "float32", isArray: false, name: "time_increment", isComplex: false },
      { type: "float32", isArray: false, name: "scan_time", isComplex: false },
      { type: "float32", isArray: false, name: "range_min", isComplex: false },
      { type: "float32", isArray: false, name: "range_max", isComplex: false },
      { type: "sensor_msgs/LaserEcho", isArray: true, name: "ranges", isComplex: true },
      { type: "sensor_msgs/LaserEcho", isArray: true, name: "intensities", isComplex: true },
    ],
  },
  "sensor_msgs/LaserEcho": {
    name: "sensor_msgs/LaserEcho",
    definitions: [{ type: "float32", isArray: true, name: "echoes", isComplex: false }],
  },
  "sensor_msgs/NavSatFix": {
    name: "sensor_msgs/NavSatFix",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "sensor_msgs/NavSatStatus", isArray: false, name: "status", isComplex: true },
      { type: "float64", isArray: false, name: "latitude", isComplex: false },
      { type: "float64", isArray: false, name: "longitude", isComplex: false },
      { type: "float64", isArray: false, name: "altitude", isComplex: false },
      {
        type: "float64",
        isArray: true,
        arrayLength: 9,
        name: "position_covariance",
        isComplex: false,
      },
      {
        type: "uint8",
        name: "COVARIANCE_TYPE_UNKNOWN",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        type: "uint8",
        name: "COVARIANCE_TYPE_APPROXIMATED",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        type: "uint8",
        name: "COVARIANCE_TYPE_DIAGONAL_KNOWN",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      { type: "uint8", name: "COVARIANCE_TYPE_KNOWN", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", isArray: false, name: "position_covariance_type", isComplex: false },
    ],
  },
  "sensor_msgs/NavSatStatus": {
    name: "sensor_msgs/NavSatStatus",
    definitions: [
      { type: "int8", name: "STATUS_NO_FIX", isConstant: true, value: -1, valueText: "-1" },
      { type: "int8", name: "STATUS_FIX", isConstant: true, value: 0, valueText: "0" },
      { type: "int8", name: "STATUS_SBAS_FIX", isConstant: true, value: 1, valueText: "1" },
      { type: "int8", name: "STATUS_GBAS_FIX", isConstant: true, value: 2, valueText: "2" },
      { type: "int8", isArray: false, name: "status", isComplex: false },
      { type: "uint16", name: "SERVICE_GPS", isConstant: true, value: 1, valueText: "1" },
      { type: "uint16", name: "SERVICE_GLONASS", isConstant: true, value: 2, valueText: "2" },
      { type: "uint16", name: "SERVICE_COMPASS", isConstant: true, value: 4, valueText: "4" },
      { type: "uint16", name: "SERVICE_GALILEO", isConstant: true, value: 8, valueText: "8" },
      { type: "uint16", isArray: false, name: "service", isComplex: false },
    ],
  },
  "sensor_msgs/PointCloud2": {
    name: "sensor_msgs/PointCloud2",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "uint32", isArray: false, name: "height", isComplex: false },
      { type: "uint32", isArray: false, name: "width", isComplex: false },
      { type: "sensor_msgs/PointField", isArray: true, name: "fields", isComplex: true },
      { type: "bool", isArray: false, name: "is_bigendian", isComplex: false },
      { type: "uint32", isArray: false, name: "point_step", isComplex: false },
      { type: "uint32", isArray: false, name: "row_step", isComplex: false },
      { type: "uint8", isArray: true, name: "data", isComplex: false },
      { type: "bool", isArray: false, name: "is_dense", isComplex: false },
    ],
  },
  "sensor_msgs/PointField": {
    name: "sensor_msgs/PointField",
    definitions: [
      { type: "uint8", name: "INT8", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "UINT8", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "INT16", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", name: "UINT16", isConstant: true, value: 4, valueText: "4" },
      { type: "uint8", name: "INT32", isConstant: true, value: 5, valueText: "5" },
      { type: "uint8", name: "UINT32", isConstant: true, value: 6, valueText: "6" },
      { type: "uint8", name: "FLOAT32", isConstant: true, value: 7, valueText: "7" },
      { type: "uint8", name: "FLOAT64", isConstant: true, value: 8, valueText: "8" },
      { type: "string", isArray: false, name: "name", isComplex: false },
      { type: "uint32", isArray: false, name: "offset", isComplex: false },
      { type: "uint8", isArray: false, name: "datatype", isComplex: false },
      { type: "uint32", isArray: false, name: "count", isComplex: false },
    ],
  },
  "sensor_msgs/Range": {
    name: "sensor_msgs/Range",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "uint8", name: "ULTRASOUND", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "INFRARED", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", isArray: false, name: "radiation_type", isComplex: false },
      { type: "float32", isArray: false, name: "field_of_view", isComplex: false },
      { type: "float32", isArray: false, name: "min_range", isComplex: false },
      { type: "float32", isArray: false, name: "max_range", isComplex: false },
      { type: "float32", isArray: false, name: "range", isComplex: false },
    ],
  },
  "sensor_msgs/RelativeHumidity": {
    name: "sensor_msgs/RelativeHumidity",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float64", isArray: false, name: "relative_humidity", isComplex: false },
      { type: "float64", isArray: false, name: "variance", isComplex: false },
    ],
  },
  "sensor_msgs/Temperature": {
    name: "sensor_msgs/Temperature",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "float64", isArray: false, name: "temperature", isComplex: false },
      { type: "float64", isArray: false, name: "variance", isComplex: false },
    ],
  },
  "sensor_msgs/TimeReference": {
    name: "sensor_msgs/TimeReference",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "time", isArray: false, name: "time_ref", isComplex: false },
      { type: "string", isArray: false, name: "source", isComplex: false },
    ],
  },
  "shape_msgs/Mesh": {
    name: "shape_msgs/Mesh",
    definitions: [
      { type: "shape_msgs/MeshTriangle", isArray: true, name: "triangles", isComplex: true },
      { type: "geometry_msgs/Point", isArray: true, name: "vertices", isComplex: true },
    ],
  },
  "shape_msgs/MeshTriangle": {
    name: "shape_msgs/MeshTriangle",
    definitions: [
      { type: "uint32", isArray: true, arrayLength: 3, name: "vertex_indices", isComplex: false },
    ],
  },
  "shape_msgs/Plane": {
    name: "shape_msgs/Plane",
    definitions: [
      { type: "float64", isArray: true, arrayLength: 4, name: "coef", isComplex: false },
    ],
  },
  "shape_msgs/SolidPrimitive": {
    name: "shape_msgs/SolidPrimitive",
    definitions: [
      { type: "uint8", name: "BOX", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "SPHERE", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "CYLINDER", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", name: "CONE", isConstant: true, value: 4, valueText: "4" },
      { type: "uint8", isArray: false, name: "type", isComplex: false },
      { type: "float64", isArray: true, name: "dimensions", isComplex: false },
      { type: "uint8", name: "BOX_X", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "BOX_Y", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "BOX_Z", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "SPHERE_RADIUS", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "CYLINDER_HEIGHT", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "CYLINDER_RADIUS", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "CONE_HEIGHT", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "CONE_RADIUS", isConstant: true, value: 1, valueText: "1" },
    ],
  },
  "std_msgs/Bool": {
    name: "std_msgs/Bool",
    definitions: [{ type: "bool", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Byte": {
    name: "std_msgs/Byte",
    definitions: [{ type: "int8", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/ByteMultiArray": {
    name: "std_msgs/ByteMultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "int8", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/MultiArrayLayout": {
    name: "std_msgs/MultiArrayLayout",
    definitions: [
      { type: "std_msgs/MultiArrayDimension", isArray: true, name: "dim", isComplex: true },
      { type: "uint32", isArray: false, name: "data_offset", isComplex: false },
    ],
  },
  "std_msgs/MultiArrayDimension": {
    name: "std_msgs/MultiArrayDimension",
    definitions: [
      { type: "string", isArray: false, name: "label", isComplex: false },
      { type: "uint32", isArray: false, name: "size", isComplex: false },
      { type: "uint32", isArray: false, name: "stride", isComplex: false },
    ],
  },
  "std_msgs/Char": {
    name: "std_msgs/Char",
    definitions: [{ type: "uint8", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/ColorRGBA": {
    name: "std_msgs/ColorRGBA",
    definitions: [
      { type: "float32", isArray: false, name: "r", isComplex: false },
      { type: "float32", isArray: false, name: "g", isComplex: false },
      { type: "float32", isArray: false, name: "b", isComplex: false },
      { type: "float32", isArray: false, name: "a", isComplex: false },
    ],
  },
  "std_msgs/Duration": {
    name: "std_msgs/Duration",
    definitions: [{ type: "duration", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Empty": { name: "std_msgs/Empty", definitions: [] },
  "std_msgs/Float32": {
    name: "std_msgs/Float32",
    definitions: [{ type: "float32", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Float32MultiArray": {
    name: "std_msgs/Float32MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "float32", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/Float64": {
    name: "std_msgs/Float64",
    definitions: [{ type: "float64", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Float64MultiArray": {
    name: "std_msgs/Float64MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "float64", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/Int16": {
    name: "std_msgs/Int16",
    definitions: [{ type: "int16", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Int16MultiArray": {
    name: "std_msgs/Int16MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "int16", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/Int32": {
    name: "std_msgs/Int32",
    definitions: [{ type: "int32", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Int32MultiArray": {
    name: "std_msgs/Int32MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "int32", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/Int64": {
    name: "std_msgs/Int64",
    definitions: [{ type: "int64", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Int64MultiArray": {
    name: "std_msgs/Int64MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "int64", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/Int8": {
    name: "std_msgs/Int8",
    definitions: [{ type: "int8", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Int8MultiArray": {
    name: "std_msgs/Int8MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "int8", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/String": {
    name: "std_msgs/String",
    definitions: [{ type: "string", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/Time": {
    name: "std_msgs/Time",
    definitions: [{ type: "time", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/UInt16": {
    name: "std_msgs/UInt16",
    definitions: [{ type: "uint16", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/UInt16MultiArray": {
    name: "std_msgs/UInt16MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "uint16", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/UInt32": {
    name: "std_msgs/UInt32",
    definitions: [{ type: "uint32", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/UInt32MultiArray": {
    name: "std_msgs/UInt32MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "uint32", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/UInt64": {
    name: "std_msgs/UInt64",
    definitions: [{ type: "uint64", isArray: false, name: "data", isComplex: false }],
  },
  "std_msgs/UInt64MultiArray": {
    name: "std_msgs/UInt64MultiArray",
    definitions: [
      { type: "std_msgs/MultiArrayLayout", isArray: false, name: "layout", isComplex: true },
      { type: "uint64", isArray: true, name: "data", isComplex: false },
    ],
  },
  "std_msgs/UInt8": {
    name: "std_msgs/UInt8",
    definitions: [{ type: "uint8", isArray: false, name: "data", isComplex: false }],
  },
  "stereo_msgs/DisparityImage": {
    name: "stereo_msgs/DisparityImage",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "sensor_msgs/Image", isArray: false, name: "image", isComplex: true },
      { type: "float32", isArray: false, name: "f", isComplex: false },
      { type: "float32", isArray: false, name: "T", isComplex: false },
      {
        type: "sensor_msgs/RegionOfInterest",
        isArray: false,
        name: "valid_window",
        isComplex: true,
      },
      { type: "float32", isArray: false, name: "min_disparity", isComplex: false },
      { type: "float32", isArray: false, name: "max_disparity", isComplex: false },
      { type: "float32", isArray: false, name: "delta_d", isComplex: false },
    ],
  },
  "tf2_msgs/TFMessage": {
    name: "tf2_msgs/TFMessage",
    definitions: [
      {
        type: "geometry_msgs/TransformStamped",
        isArray: true,
        name: "transforms",
        isComplex: true,
      },
    ],
  },
  "trajectory_msgs/JointTrajectory": {
    name: "trajectory_msgs/JointTrajectory",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: true, name: "joint_names", isComplex: false },
      {
        type: "trajectory_msgs/JointTrajectoryPoint",
        isArray: true,
        name: "points",
        isComplex: true,
      },
    ],
  },
  "trajectory_msgs/JointTrajectoryPoint": {
    name: "trajectory_msgs/JointTrajectoryPoint",
    definitions: [
      { type: "float64", isArray: true, name: "positions", isComplex: false },
      { type: "float64", isArray: true, name: "velocities", isComplex: false },
      { type: "float64", isArray: true, name: "accelerations", isComplex: false },
      { type: "float64", isArray: true, name: "effort", isComplex: false },
      { type: "duration", isArray: false, name: "time_from_start", isComplex: false },
    ],
  },
  "trajectory_msgs/MultiDOFJointTrajectory": {
    name: "trajectory_msgs/MultiDOFJointTrajectory",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: true, name: "joint_names", isComplex: false },
      {
        type: "trajectory_msgs/MultiDOFJointTrajectoryPoint",
        isArray: true,
        name: "points",
        isComplex: true,
      },
    ],
  },
  "trajectory_msgs/MultiDOFJointTrajectoryPoint": {
    name: "trajectory_msgs/MultiDOFJointTrajectoryPoint",
    definitions: [
      { type: "geometry_msgs/Transform", isArray: true, name: "transforms", isComplex: true },
      { type: "geometry_msgs/Twist", isArray: true, name: "velocities", isComplex: true },
      { type: "geometry_msgs/Twist", isArray: true, name: "accelerations", isComplex: true },
      { type: "duration", isArray: false, name: "time_from_start", isComplex: false },
    ],
  },
  "velodyne_msgs/VelodynePacket": {
    name: "velodyne_msgs/VelodynePacket",
    definitions: [
      { type: "time", isArray: false, name: "stamp", isComplex: false },
      { type: "uint8", isArray: true, arrayLength: 1206, name: "data", isComplex: false },
    ],
  },
  "velodyne_msgs/VelodyneScan": {
    name: "velodyne_msgs/VelodyneScan",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "velodyne_msgs/VelodynePacket", isArray: true, name: "packets", isComplex: true },
    ],
  },
  "visualization_msgs/ImageMarker": {
    name: "visualization_msgs/ImageMarker",
    definitions: [
      { type: "uint8", name: "CIRCLE", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "LINE_STRIP", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "LINE_LIST", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "POLYGON", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", name: "POINTS", isConstant: true, value: 4, valueText: "4" },
      { type: "uint8", name: "ADD", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "REMOVE", isConstant: true, value: 1, valueText: "1" },
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: false, name: "ns", isComplex: false },
      { type: "int32", isArray: false, name: "id", isComplex: false },
      { type: "int32", isArray: false, name: "type", isComplex: false },
      { type: "int32", isArray: false, name: "action", isComplex: false },
      { type: "geometry_msgs/Point", isArray: false, name: "position", isComplex: true },
      { type: "float32", isArray: false, name: "scale", isComplex: false },
      { type: "std_msgs/ColorRGBA", isArray: false, name: "outline_color", isComplex: true },
      { type: "uint8", isArray: false, name: "filled", isComplex: false },
      { type: "std_msgs/ColorRGBA", isArray: false, name: "fill_color", isComplex: true },
      { type: "duration", isArray: false, name: "lifetime", isComplex: false },
      { type: "geometry_msgs/Point", isArray: true, name: "points", isComplex: true },
      { type: "std_msgs/ColorRGBA", isArray: true, name: "outline_colors", isComplex: true },
    ],
  },
  "visualization_msgs/InteractiveMarker": {
    name: "visualization_msgs/InteractiveMarker",
    definitions: [
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "geometry_msgs/Pose", isArray: false, name: "pose", isComplex: true },
      { type: "string", isArray: false, name: "name", isComplex: false },
      { type: "string", isArray: false, name: "description", isComplex: false },
      { type: "float32", isArray: false, name: "scale", isComplex: false },
      {
        type: "visualization_msgs/MenuEntry",
        isArray: true,
        name: "menu_entries",
        isComplex: true,
      },
      {
        type: "visualization_msgs/InteractiveMarkerControl",
        isArray: true,
        name: "controls",
        isComplex: true,
      },
    ],
  },
  "visualization_msgs/MenuEntry": {
    name: "visualization_msgs/MenuEntry",
    definitions: [
      { type: "uint32", isArray: false, name: "id", isComplex: false },
      { type: "uint32", isArray: false, name: "parent_id", isComplex: false },
      { type: "string", isArray: false, name: "title", isComplex: false },
      { type: "string", isArray: false, name: "command", isComplex: false },
      { type: "uint8", name: "FEEDBACK", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "ROSRUN", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "ROSLAUNCH", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", isArray: false, name: "command_type", isComplex: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerControl": {
    name: "visualization_msgs/InteractiveMarkerControl",
    definitions: [
      { type: "string", isArray: false, name: "name", isComplex: false },
      { type: "geometry_msgs/Quaternion", isArray: false, name: "orientation", isComplex: true },
      { type: "uint8", name: "INHERIT", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "FIXED", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "VIEW_FACING", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", isArray: false, name: "orientation_mode", isComplex: false },
      { type: "uint8", name: "NONE", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "MENU", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "BUTTON", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "MOVE_AXIS", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", name: "MOVE_PLANE", isConstant: true, value: 4, valueText: "4" },
      { type: "uint8", name: "ROTATE_AXIS", isConstant: true, value: 5, valueText: "5" },
      { type: "uint8", name: "MOVE_ROTATE", isConstant: true, value: 6, valueText: "6" },
      { type: "uint8", name: "MOVE_3D", isConstant: true, value: 7, valueText: "7" },
      { type: "uint8", name: "ROTATE_3D", isConstant: true, value: 8, valueText: "8" },
      { type: "uint8", name: "MOVE_ROTATE_3D", isConstant: true, value: 9, valueText: "9" },
      { type: "uint8", isArray: false, name: "interaction_mode", isComplex: false },
      { type: "bool", isArray: false, name: "always_visible", isComplex: false },
      { type: "visualization_msgs/Marker", isArray: true, name: "markers", isComplex: true },
      { type: "bool", isArray: false, name: "independent_marker_orientation", isComplex: false },
      { type: "string", isArray: false, name: "description", isComplex: false },
    ],
  },
  "visualization_msgs/Marker": {
    name: "visualization_msgs/Marker",
    definitions: [
      { type: "uint8", name: "ARROW", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "CUBE", isConstant: true, value: 1, valueText: "1" },
      { type: "uint8", name: "SPHERE", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "CYLINDER", isConstant: true, value: 3, valueText: "3" },
      { type: "uint8", name: "LINE_STRIP", isConstant: true, value: 4, valueText: "4" },
      { type: "uint8", name: "LINE_LIST", isConstant: true, value: 5, valueText: "5" },
      { type: "uint8", name: "CUBE_LIST", isConstant: true, value: 6, valueText: "6" },
      { type: "uint8", name: "SPHERE_LIST", isConstant: true, value: 7, valueText: "7" },
      { type: "uint8", name: "POINTS", isConstant: true, value: 8, valueText: "8" },
      { type: "uint8", name: "TEXT_VIEW_FACING", isConstant: true, value: 9, valueText: "9" },
      { type: "uint8", name: "MESH_RESOURCE", isConstant: true, value: 10, valueText: "10" },
      { type: "uint8", name: "TRIANGLE_LIST", isConstant: true, value: 11, valueText: "11" },
      { type: "uint8", name: "ADD", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "MODIFY", isConstant: true, value: 0, valueText: "0" },
      { type: "uint8", name: "DELETE", isConstant: true, value: 2, valueText: "2" },
      { type: "uint8", name: "DELETEALL", isConstant: true, value: 3, valueText: "3" },
      { type: "std_msgs/Header", isArray: false, name: "header", isComplex: true },
      { type: "string", isArray: false, name: "ns", isComplex: false },
      { type: "int32", isArray: false, name: "id", isComplex: false },
      { type: "int32", isArray: false, name: "type", isComplex: false },
      { type: "int32", isArray: false, name: "action", isComplex: false },
      { type: "geometry_msgs/Pose", isArray: false, name: "pose", isComplex: true },
      { type: "geometry_msgs/Vector3", isArray: false, name: "scale", isComplex: true },
      { type: "std_msgs/ColorRGBA", isArray: false, name: "color", isComplex: true },
      { type: "duration", isArray: false, name: "lifetime", isComplex: false },
      { type: "bool", isArray: false, name: "frame_locked", isComplex: false },
      { type: "geometry_msgs/Point", isArray: true, name: "points", isComplex: true },
      { type: "std_msgs/ColorRGBA", isArray: true, name: "colors", isComplex: true },
      { type: "string", isArray: false, name: "text", isComplex: false },
      { type: "string", isArray: false, name: "mesh_resource", isComplex: false },
      { type: "bool", isArray: false, name: "mesh_use_embedded_materials", isComplex: false },
    ],
  },
  "visualization_msgs/MarkerArray": {
    name: "visualization_msgs/MarkerArray",
    definitions: [
      { type: "visualization_msgs/Marker", isArray: true, name: "markers", isComplex: true },
    ],
  },
};
module.exports.ros1 = ros1Definitions;

const ros2galacticDefinitions = {
  "action_msgs/GoalInfo": {
    name: "action_msgs/GoalInfo",
    definitions: [
      { name: "goal_id", type: "unique_identifier_msgs/UUID", isComplex: true, isArray: false },
      { name: "stamp", type: "time", isComplex: false, isArray: false },
    ],
  },
  "unique_identifier_msgs/UUID": {
    name: "unique_identifier_msgs/UUID",
    definitions: [
      { name: "uuid", type: "uint8", isComplex: false, isArray: true, arrayLength: 16 },
    ],
  },
  "action_msgs/GoalStatus": {
    name: "action_msgs/GoalStatus",
    definitions: [
      { name: "STATUS_UNKNOWN", type: "int8", isConstant: true, value: 0, valueText: "0" },
      { name: "STATUS_ACCEPTED", type: "int8", isConstant: true, value: 1, valueText: "1" },
      { name: "STATUS_EXECUTING", type: "int8", isConstant: true, value: 2, valueText: "2" },
      { name: "STATUS_CANCELING", type: "int8", isConstant: true, value: 3, valueText: "3" },
      { name: "STATUS_SUCCEEDED", type: "int8", isConstant: true, value: 4, valueText: "4" },
      { name: "STATUS_CANCELED", type: "int8", isConstant: true, value: 5, valueText: "5" },
      { name: "STATUS_ABORTED", type: "int8", isConstant: true, value: 6, valueText: "6" },
      { name: "goal_info", type: "action_msgs/GoalInfo", isComplex: true, isArray: false },
      { name: "status", type: "int8", isComplex: false, isArray: false },
    ],
  },
  "action_msgs/GoalStatusArray": {
    name: "action_msgs/GoalStatusArray",
    definitions: [
      { name: "status_list", type: "action_msgs/GoalStatus", isComplex: true, isArray: true },
    ],
  },
  "actionlib_msgs/GoalID": {
    name: "actionlib_msgs/GoalID",
    definitions: [
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "id", type: "string", isComplex: false, isArray: false },
    ],
  },
  "actionlib_msgs/GoalStatus": {
    name: "actionlib_msgs/GoalStatus",
    definitions: [
      { name: "goal_id", type: "actionlib_msgs/GoalID", isComplex: true, isArray: false },
      { name: "status", type: "uint8", isComplex: false, isArray: false },
      { name: "PENDING", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "ACTIVE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "PREEMPTED", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "SUCCEEDED", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "ABORTED", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "REJECTED", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "PREEMPTING", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      { name: "RECALLING", type: "uint8", isConstant: true, value: 7, valueText: "7" },
      { name: "RECALLED", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "LOST", type: "uint8", isConstant: true, value: 9, valueText: "9" },
      { name: "text", type: "string", isComplex: false, isArray: false },
    ],
  },
  "actionlib_msgs/GoalStatusArray": {
    name: "actionlib_msgs/GoalStatusArray",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "status_list", type: "actionlib_msgs/GoalStatus", isComplex: true, isArray: true },
    ],
  },
  "std_msgs/Header": {
    name: "std_msgs/Header",
    definitions: [
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "frame_id", type: "string", isComplex: false, isArray: false },
    ],
  },
  "builtin_interfaces/Duration": {
    name: "builtin_interfaces/Duration",
    definitions: [
      { name: "sec", type: "int32", isComplex: false, isArray: false },
      { name: "nanosec", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "builtin_interfaces/Time": {
    name: "builtin_interfaces/Time",
    definitions: [
      { name: "sec", type: "int32", isComplex: false, isArray: false },
      { name: "nanosec", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "diagnostic_msgs/DiagnosticArray": {
    name: "diagnostic_msgs/DiagnosticArray",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "status", type: "diagnostic_msgs/DiagnosticStatus", isComplex: true, isArray: true },
    ],
  },
  "diagnostic_msgs/DiagnosticStatus": {
    name: "diagnostic_msgs/DiagnosticStatus",
    definitions: [
      { name: "OK", type: "int8", isConstant: true, value: 0, valueText: "0" },
      { name: "WARN", type: "int8", isConstant: true, value: 1, valueText: "1" },
      { name: "ERROR", type: "int8", isConstant: true, value: 2, valueText: "2" },
      { name: "STALE", type: "int8", isConstant: true, value: 3, valueText: "3" },
      { name: "level", type: "int8", isComplex: false, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "message", type: "string", isComplex: false, isArray: false },
      { name: "hardware_id", type: "string", isComplex: false, isArray: false },
      { name: "values", type: "diagnostic_msgs/KeyValue", isComplex: true, isArray: true },
    ],
  },
  "diagnostic_msgs/KeyValue": {
    name: "diagnostic_msgs/KeyValue",
    definitions: [
      { name: "key", type: "string", isComplex: false, isArray: false },
      { name: "value", type: "string", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/Accel": {
    name: "geometry_msgs/Accel",
    definitions: [
      { name: "linear", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "angular", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Vector3": {
    name: "geometry_msgs/Vector3",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false },
      { name: "y", type: "float64", isComplex: false, isArray: false },
      { name: "z", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/AccelStamped": {
    name: "geometry_msgs/AccelStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "accel", type: "geometry_msgs/Accel", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/AccelWithCovariance": {
    name: "geometry_msgs/AccelWithCovariance",
    definitions: [
      { name: "accel", type: "geometry_msgs/Accel", isComplex: true, isArray: false },
      { name: "covariance", type: "float64", isComplex: false, isArray: true, arrayLength: 36 },
    ],
  },
  "geometry_msgs/AccelWithCovarianceStamped": {
    name: "geometry_msgs/AccelWithCovarianceStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "accel", type: "geometry_msgs/AccelWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Inertia": {
    name: "geometry_msgs/Inertia",
    definitions: [
      { name: "m", type: "float64", isComplex: false, isArray: false },
      { name: "com", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "ixx", type: "float64", isComplex: false, isArray: false },
      { name: "ixy", type: "float64", isComplex: false, isArray: false },
      { name: "ixz", type: "float64", isComplex: false, isArray: false },
      { name: "iyy", type: "float64", isComplex: false, isArray: false },
      { name: "iyz", type: "float64", isComplex: false, isArray: false },
      { name: "izz", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/InertiaStamped": {
    name: "geometry_msgs/InertiaStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "inertia", type: "geometry_msgs/Inertia", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Point": {
    name: "geometry_msgs/Point",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false },
      { name: "y", type: "float64", isComplex: false, isArray: false },
      { name: "z", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/Point32": {
    name: "geometry_msgs/Point32",
    definitions: [
      { name: "x", type: "float32", isComplex: false, isArray: false },
      { name: "y", type: "float32", isComplex: false, isArray: false },
      { name: "z", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/PointStamped": {
    name: "geometry_msgs/PointStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "point", type: "geometry_msgs/Point", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Polygon": {
    name: "geometry_msgs/Polygon",
    definitions: [
      { name: "points", type: "geometry_msgs/Point32", isComplex: true, isArray: true },
    ],
  },
  "geometry_msgs/PolygonStamped": {
    name: "geometry_msgs/PolygonStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "polygon", type: "geometry_msgs/Polygon", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Pose": {
    name: "geometry_msgs/Pose",
    definitions: [
      { name: "position", type: "geometry_msgs/Point", isComplex: true, isArray: false },
      { name: "orientation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Quaternion": {
    name: "geometry_msgs/Quaternion",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false, defaultValue: 0 },
      { name: "y", type: "float64", isComplex: false, isArray: false, defaultValue: 0 },
      { name: "z", type: "float64", isComplex: false, isArray: false, defaultValue: 0 },
      { name: "w", type: "float64", isComplex: false, isArray: false, defaultValue: 1 },
    ],
  },
  "geometry_msgs/Pose2D": {
    name: "geometry_msgs/Pose2D",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false },
      { name: "y", type: "float64", isComplex: false, isArray: false },
      { name: "theta", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/PoseArray": {
    name: "geometry_msgs/PoseArray",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "poses", type: "geometry_msgs/Pose", isComplex: true, isArray: true },
    ],
  },
  "geometry_msgs/PoseStamped": {
    name: "geometry_msgs/PoseStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/PoseWithCovariance": {
    name: "geometry_msgs/PoseWithCovariance",
    definitions: [
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "covariance", type: "float64", isComplex: false, isArray: true, arrayLength: 36 },
    ],
  },
  "geometry_msgs/PoseWithCovarianceStamped": {
    name: "geometry_msgs/PoseWithCovarianceStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/PoseWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/QuaternionStamped": {
    name: "geometry_msgs/QuaternionStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "quaternion", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Transform": {
    name: "geometry_msgs/Transform",
    definitions: [
      { name: "translation", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "rotation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/TransformStamped": {
    name: "geometry_msgs/TransformStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "child_frame_id", type: "string", isComplex: false, isArray: false },
      { name: "transform", type: "geometry_msgs/Transform", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Twist": {
    name: "geometry_msgs/Twist",
    definitions: [
      { name: "linear", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "angular", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/TwistStamped": {
    name: "geometry_msgs/TwistStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "twist", type: "geometry_msgs/Twist", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/TwistWithCovariance": {
    name: "geometry_msgs/TwistWithCovariance",
    definitions: [
      { name: "twist", type: "geometry_msgs/Twist", isComplex: true, isArray: false },
      { name: "covariance", type: "float64", isComplex: false, isArray: true, arrayLength: 36 },
    ],
  },
  "geometry_msgs/TwistWithCovarianceStamped": {
    name: "geometry_msgs/TwistWithCovarianceStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "twist", type: "geometry_msgs/TwistWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Vector3Stamped": {
    name: "geometry_msgs/Vector3Stamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "vector", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Wrench": {
    name: "geometry_msgs/Wrench",
    definitions: [
      { name: "force", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "torque", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/WrenchStamped": {
    name: "geometry_msgs/WrenchStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "wrench", type: "geometry_msgs/Wrench", isComplex: true, isArray: false },
    ],
  },
  "lifecycle_msgs/State": {
    name: "lifecycle_msgs/State",
    definitions: [
      { name: "PRIMARY_STATE_UNKNOWN", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      {
        name: "PRIMARY_STATE_UNCONFIGURED",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      { name: "PRIMARY_STATE_INACTIVE", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "PRIMARY_STATE_ACTIVE", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      {
        name: "PRIMARY_STATE_FINALIZED",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "TRANSITION_STATE_CONFIGURING",
        type: "uint8",
        isConstant: true,
        value: 10,
        valueText: "10",
      },
      {
        name: "TRANSITION_STATE_CLEANINGUP",
        type: "uint8",
        isConstant: true,
        value: 11,
        valueText: "11",
      },
      {
        name: "TRANSITION_STATE_SHUTTINGDOWN",
        type: "uint8",
        isConstant: true,
        value: 12,
        valueText: "12",
      },
      {
        name: "TRANSITION_STATE_ACTIVATING",
        type: "uint8",
        isConstant: true,
        value: 13,
        valueText: "13",
      },
      {
        name: "TRANSITION_STATE_DEACTIVATING",
        type: "uint8",
        isConstant: true,
        value: 14,
        valueText: "14",
      },
      {
        name: "TRANSITION_STATE_ERRORPROCESSING",
        type: "uint8",
        isConstant: true,
        value: 15,
        valueText: "15",
      },
      { name: "id", type: "uint8", isComplex: false, isArray: false },
      { name: "label", type: "string", isComplex: false, isArray: false },
    ],
  },
  "lifecycle_msgs/Transition": {
    name: "lifecycle_msgs/Transition",
    definitions: [
      { name: "TRANSITION_CREATE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "TRANSITION_CONFIGURE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "TRANSITION_CLEANUP", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "TRANSITION_ACTIVATE", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "TRANSITION_DEACTIVATE", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      {
        name: "TRANSITION_UNCONFIGURED_SHUTDOWN",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        name: "TRANSITION_INACTIVE_SHUTDOWN",
        type: "uint8",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      {
        name: "TRANSITION_ACTIVE_SHUTDOWN",
        type: "uint8",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      { name: "TRANSITION_DESTROY", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      {
        name: "TRANSITION_ON_CONFIGURE_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 10,
        valueText: "10",
      },
      {
        name: "TRANSITION_ON_CONFIGURE_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 11,
        valueText: "11",
      },
      {
        name: "TRANSITION_ON_CONFIGURE_ERROR",
        type: "uint8",
        isConstant: true,
        value: 12,
        valueText: "12",
      },
      {
        name: "TRANSITION_ON_CLEANUP_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 20,
        valueText: "20",
      },
      {
        name: "TRANSITION_ON_CLEANUP_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 21,
        valueText: "21",
      },
      {
        name: "TRANSITION_ON_CLEANUP_ERROR",
        type: "uint8",
        isConstant: true,
        value: 22,
        valueText: "22",
      },
      {
        name: "TRANSITION_ON_ACTIVATE_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 30,
        valueText: "30",
      },
      {
        name: "TRANSITION_ON_ACTIVATE_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 31,
        valueText: "31",
      },
      {
        name: "TRANSITION_ON_ACTIVATE_ERROR",
        type: "uint8",
        isConstant: true,
        value: 32,
        valueText: "32",
      },
      {
        name: "TRANSITION_ON_DEACTIVATE_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 40,
        valueText: "40",
      },
      {
        name: "TRANSITION_ON_DEACTIVATE_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 41,
        valueText: "41",
      },
      {
        name: "TRANSITION_ON_DEACTIVATE_ERROR",
        type: "uint8",
        isConstant: true,
        value: 42,
        valueText: "42",
      },
      {
        name: "TRANSITION_ON_SHUTDOWN_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 50,
        valueText: "50",
      },
      {
        name: "TRANSITION_ON_SHUTDOWN_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 51,
        valueText: "51",
      },
      {
        name: "TRANSITION_ON_SHUTDOWN_ERROR",
        type: "uint8",
        isConstant: true,
        value: 52,
        valueText: "52",
      },
      {
        name: "TRANSITION_ON_ERROR_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 60,
        valueText: "60",
      },
      {
        name: "TRANSITION_ON_ERROR_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 61,
        valueText: "61",
      },
      {
        name: "TRANSITION_ON_ERROR_ERROR",
        type: "uint8",
        isConstant: true,
        value: 62,
        valueText: "62",
      },
      {
        name: "TRANSITION_CALLBACK_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 97,
        valueText: "97",
      },
      {
        name: "TRANSITION_CALLBACK_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 98,
        valueText: "98",
      },
      {
        name: "TRANSITION_CALLBACK_ERROR",
        type: "uint8",
        isConstant: true,
        value: 99,
        valueText: "99",
      },
      { name: "id", type: "uint8", isComplex: false, isArray: false },
      { name: "label", type: "string", isComplex: false, isArray: false },
    ],
  },
  "lifecycle_msgs/TransitionDescription": {
    name: "lifecycle_msgs/TransitionDescription",
    definitions: [
      { name: "transition", type: "lifecycle_msgs/Transition", isComplex: true, isArray: false },
      { name: "start_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
      { name: "goal_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
    ],
  },
  "lifecycle_msgs/TransitionEvent": {
    name: "lifecycle_msgs/TransitionEvent",
    definitions: [
      { name: "timestamp", type: "uint64", isComplex: false, isArray: false },
      { name: "transition", type: "lifecycle_msgs/Transition", isComplex: true, isArray: false },
      { name: "start_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
      { name: "goal_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
    ],
  },
  "nav_msgs/GridCells": {
    name: "nav_msgs/GridCells",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "cell_width", type: "float32", isComplex: false, isArray: false },
      { name: "cell_height", type: "float32", isComplex: false, isArray: false },
      { name: "cells", type: "geometry_msgs/Point", isComplex: true, isArray: true },
    ],
  },
  "nav_msgs/MapMetaData": {
    name: "nav_msgs/MapMetaData",
    definitions: [
      { name: "map_load_time", type: "time", isComplex: false, isArray: false },
      { name: "resolution", type: "float32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "origin", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
    ],
  },
  "nav_msgs/OccupancyGrid": {
    name: "nav_msgs/OccupancyGrid",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "info", type: "nav_msgs/MapMetaData", isComplex: true, isArray: false },
      { name: "data", type: "int8", isComplex: false, isArray: true },
    ],
  },
  "nav_msgs/Odometry": {
    name: "nav_msgs/Odometry",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "child_frame_id", type: "string", isComplex: false, isArray: false },
      { name: "pose", type: "geometry_msgs/PoseWithCovariance", isComplex: true, isArray: false },
      { name: "twist", type: "geometry_msgs/TwistWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "nav_msgs/Path": {
    name: "nav_msgs/Path",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "poses", type: "geometry_msgs/PoseStamped", isComplex: true, isArray: true },
    ],
  },
  "rcl_interfaces/FloatingPointRange": {
    name: "rcl_interfaces/FloatingPointRange",
    definitions: [
      { name: "from_value", type: "float64", isComplex: false, isArray: false },
      { name: "to_value", type: "float64", isComplex: false, isArray: false },
      { name: "step", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "rcl_interfaces/IntegerRange": {
    name: "rcl_interfaces/IntegerRange",
    definitions: [
      { name: "from_value", type: "int64", isComplex: false, isArray: false },
      { name: "to_value", type: "int64", isComplex: false, isArray: false },
      { name: "step", type: "uint64", isComplex: false, isArray: false },
    ],
  },
  "rcl_interfaces/ListParametersResult": {
    name: "rcl_interfaces/ListParametersResult",
    definitions: [
      { name: "names", type: "string", isComplex: false, isArray: true },
      { name: "prefixes", type: "string", isComplex: false, isArray: true },
    ],
  },
  "rcl_interfaces/Log": {
    name: "rcl_interfaces/Log",
    definitions: [
      { name: "DEBUG", type: "int8", isConstant: true, value: 10, valueText: "10" },
      { name: "INFO", type: "int8", isConstant: true, value: 20, valueText: "20" },
      { name: "WARN", type: "int8", isConstant: true, value: 30, valueText: "30" },
      { name: "ERROR", type: "int8", isConstant: true, value: 40, valueText: "40" },
      { name: "FATAL", type: "int8", isConstant: true, value: 50, valueText: "50" },
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "level", type: "uint8", isComplex: false, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "msg", type: "string", isComplex: false, isArray: false },
      { name: "file", type: "string", isComplex: false, isArray: false },
      { name: "function", type: "string", isComplex: false, isArray: false },
      { name: "line", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "rcl_interfaces/Parameter": {
    name: "rcl_interfaces/Parameter",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "value", type: "rcl_interfaces/ParameterValue", isComplex: true, isArray: false },
    ],
  },
  "rcl_interfaces/ParameterValue": {
    name: "rcl_interfaces/ParameterValue",
    definitions: [
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "bool_value", type: "bool", isComplex: false, isArray: false },
      { name: "integer_value", type: "int64", isComplex: false, isArray: false },
      { name: "double_value", type: "float64", isComplex: false, isArray: false },
      { name: "string_value", type: "string", isComplex: false, isArray: false },
      { name: "byte_array_value", type: "int8", isComplex: false, isArray: true },
      { name: "bool_array_value", type: "bool", isComplex: false, isArray: true },
      { name: "integer_array_value", type: "int64", isComplex: false, isArray: true },
      { name: "double_array_value", type: "float64", isComplex: false, isArray: true },
      { name: "string_array_value", type: "string", isComplex: false, isArray: true },
    ],
  },
  "rcl_interfaces/ParameterDescriptor": {
    name: "rcl_interfaces/ParameterDescriptor",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "description", type: "string", isComplex: false, isArray: false },
      { name: "additional_constraints", type: "string", isComplex: false, isArray: false },
      { name: "read_only", type: "bool", isComplex: false, isArray: false, defaultValue: false },
      {
        name: "dynamic_typing",
        type: "bool",
        isComplex: false,
        isArray: false,
        defaultValue: false,
      },
      {
        name: "floating_point_range",
        type: "rcl_interfaces/FloatingPointRange",
        isComplex: true,
        isArray: true,
        arrayUpperBound: 1,
      },
      {
        name: "integer_range",
        type: "rcl_interfaces/IntegerRange",
        isComplex: true,
        isArray: true,
        arrayUpperBound: 1,
      },
    ],
  },
  "rcl_interfaces/ParameterEvent": {
    name: "rcl_interfaces/ParameterEvent",
    definitions: [
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "node", type: "string", isComplex: false, isArray: false },
      { name: "new_parameters", type: "rcl_interfaces/Parameter", isComplex: true, isArray: true },
      {
        name: "changed_parameters",
        type: "rcl_interfaces/Parameter",
        isComplex: true,
        isArray: true,
      },
      {
        name: "deleted_parameters",
        type: "rcl_interfaces/Parameter",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "rcl_interfaces/ParameterEventDescriptors": {
    name: "rcl_interfaces/ParameterEventDescriptors",
    definitions: [
      {
        name: "new_parameters",
        type: "rcl_interfaces/ParameterDescriptor",
        isComplex: true,
        isArray: true,
      },
      {
        name: "changed_parameters",
        type: "rcl_interfaces/ParameterDescriptor",
        isComplex: true,
        isArray: true,
      },
      {
        name: "deleted_parameters",
        type: "rcl_interfaces/ParameterDescriptor",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "rcl_interfaces/ParameterType": {
    name: "rcl_interfaces/ParameterType",
    definitions: [
      { name: "PARAMETER_NOT_SET", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "PARAMETER_BOOL", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "PARAMETER_INTEGER", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "PARAMETER_DOUBLE", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "PARAMETER_STRING", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "PARAMETER_BYTE_ARRAY", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "PARAMETER_BOOL_ARRAY", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      {
        name: "PARAMETER_INTEGER_ARRAY",
        type: "uint8",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      { name: "PARAMETER_DOUBLE_ARRAY", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "PARAMETER_STRING_ARRAY", type: "uint8", isConstant: true, value: 9, valueText: "9" },
    ],
  },
  "rcl_interfaces/SetParametersResult": {
    name: "rcl_interfaces/SetParametersResult",
    definitions: [
      { name: "successful", type: "bool", isComplex: false, isArray: false },
      { name: "reason", type: "string", isComplex: false, isArray: false },
    ],
  },
  "rosgraph_msgs/Clock": {
    name: "rosgraph_msgs/Clock",
    definitions: [{ name: "clock", type: "time", isComplex: false, isArray: false }],
  },
  "sensor_msgs/BatteryState": {
    name: "sensor_msgs/BatteryState",
    definitions: [
      {
        name: "POWER_SUPPLY_STATUS_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "POWER_SUPPLY_STATUS_CHARGING",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "POWER_SUPPLY_STATUS_DISCHARGING",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "POWER_SUPPLY_STATUS_NOT_CHARGING",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "POWER_SUPPLY_STATUS_FULL",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "POWER_SUPPLY_HEALTH_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "POWER_SUPPLY_HEALTH_GOOD",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "POWER_SUPPLY_HEALTH_OVERHEAT",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "POWER_SUPPLY_HEALTH_DEAD",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "POWER_SUPPLY_HEALTH_OVERVOLTAGE",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "POWER_SUPPLY_HEALTH_UNSPEC_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        name: "POWER_SUPPLY_HEALTH_COLD",
        type: "uint8",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      {
        name: "POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE",
        type: "uint8",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      {
        name: "POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE",
        type: "uint8",
        isConstant: true,
        value: 8,
        valueText: "8",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_NIMH",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LION",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LIPO",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LIFE",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_NICD",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LIMN",
        type: "uint8",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "voltage", type: "float32", isComplex: false, isArray: false },
      { name: "temperature", type: "float32", isComplex: false, isArray: false },
      { name: "current", type: "float32", isComplex: false, isArray: false },
      { name: "charge", type: "float32", isComplex: false, isArray: false },
      { name: "capacity", type: "float32", isComplex: false, isArray: false },
      { name: "design_capacity", type: "float32", isComplex: false, isArray: false },
      { name: "percentage", type: "float32", isComplex: false, isArray: false },
      { name: "power_supply_status", type: "uint8", isComplex: false, isArray: false },
      { name: "power_supply_health", type: "uint8", isComplex: false, isArray: false },
      { name: "power_supply_technology", type: "uint8", isComplex: false, isArray: false },
      { name: "present", type: "bool", isComplex: false, isArray: false },
      { name: "cell_voltage", type: "float32", isComplex: false, isArray: true },
      { name: "cell_temperature", type: "float32", isComplex: false, isArray: true },
      { name: "location", type: "string", isComplex: false, isArray: false },
      { name: "serial_number", type: "string", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/CameraInfo": {
    name: "sensor_msgs/CameraInfo",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "distortion_model", type: "string", isComplex: false, isArray: false },
      { name: "d", type: "float64", isComplex: false, isArray: true },
      { name: "k", type: "float64", isComplex: false, isArray: true, arrayLength: 9 },
      { name: "r", type: "float64", isComplex: false, isArray: true, arrayLength: 9 },
      { name: "p", type: "float64", isComplex: false, isArray: true, arrayLength: 12 },
      { name: "binning_x", type: "uint32", isComplex: false, isArray: false },
      { name: "binning_y", type: "uint32", isComplex: false, isArray: false },
      { name: "roi", type: "sensor_msgs/RegionOfInterest", isComplex: true, isArray: false },
    ],
  },
  "sensor_msgs/RegionOfInterest": {
    name: "sensor_msgs/RegionOfInterest",
    definitions: [
      { name: "x_offset", type: "uint32", isComplex: false, isArray: false },
      { name: "y_offset", type: "uint32", isComplex: false, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "do_rectify", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/ChannelFloat32": {
    name: "sensor_msgs/ChannelFloat32",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "values", type: "float32", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/CompressedImage": {
    name: "sensor_msgs/CompressedImage",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "format", type: "string", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/FluidPressure": {
    name: "sensor_msgs/FluidPressure",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "fluid_pressure", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Illuminance": {
    name: "sensor_msgs/Illuminance",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "illuminance", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Image": {
    name: "sensor_msgs/Image",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "encoding", type: "string", isComplex: false, isArray: false },
      { name: "is_bigendian", type: "uint8", isComplex: false, isArray: false },
      { name: "step", type: "uint32", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/Imu": {
    name: "sensor_msgs/Imu",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "orientation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
      {
        name: "orientation_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
      { name: "angular_velocity", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      {
        name: "angular_velocity_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
      {
        name: "linear_acceleration",
        type: "geometry_msgs/Vector3",
        isComplex: true,
        isArray: false,
      },
      {
        name: "linear_acceleration_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
    ],
  },
  "sensor_msgs/JointState": {
    name: "sensor_msgs/JointState",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: true },
      { name: "position", type: "float64", isComplex: false, isArray: true },
      { name: "velocity", type: "float64", isComplex: false, isArray: true },
      { name: "effort", type: "float64", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/Joy": {
    name: "sensor_msgs/Joy",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "axes", type: "float32", isComplex: false, isArray: true },
      { name: "buttons", type: "int32", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/JoyFeedback": {
    name: "sensor_msgs/JoyFeedback",
    definitions: [
      { name: "TYPE_LED", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "TYPE_RUMBLE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "TYPE_BUZZER", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "id", type: "uint8", isComplex: false, isArray: false },
      { name: "intensity", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/JoyFeedbackArray": {
    name: "sensor_msgs/JoyFeedbackArray",
    definitions: [
      { name: "array", type: "sensor_msgs/JoyFeedback", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/LaserEcho": {
    name: "sensor_msgs/LaserEcho",
    definitions: [{ name: "echoes", type: "float32", isComplex: false, isArray: true }],
  },
  "sensor_msgs/LaserScan": {
    name: "sensor_msgs/LaserScan",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "angle_min", type: "float32", isComplex: false, isArray: false },
      { name: "angle_max", type: "float32", isComplex: false, isArray: false },
      { name: "angle_increment", type: "float32", isComplex: false, isArray: false },
      { name: "time_increment", type: "float32", isComplex: false, isArray: false },
      { name: "scan_time", type: "float32", isComplex: false, isArray: false },
      { name: "range_min", type: "float32", isComplex: false, isArray: false },
      { name: "range_max", type: "float32", isComplex: false, isArray: false },
      { name: "ranges", type: "float32", isComplex: false, isArray: true },
      { name: "intensities", type: "float32", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/MagneticField": {
    name: "sensor_msgs/MagneticField",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "magnetic_field", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      {
        name: "magnetic_field_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
    ],
  },
  "sensor_msgs/MultiDOFJointState": {
    name: "sensor_msgs/MultiDOFJointState",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "joint_names", type: "string", isComplex: false, isArray: true },
      { name: "transforms", type: "geometry_msgs/Transform", isComplex: true, isArray: true },
      { name: "twist", type: "geometry_msgs/Twist", isComplex: true, isArray: true },
      { name: "wrench", type: "geometry_msgs/Wrench", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/MultiEchoLaserScan": {
    name: "sensor_msgs/MultiEchoLaserScan",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "angle_min", type: "float32", isComplex: false, isArray: false },
      { name: "angle_max", type: "float32", isComplex: false, isArray: false },
      { name: "angle_increment", type: "float32", isComplex: false, isArray: false },
      { name: "time_increment", type: "float32", isComplex: false, isArray: false },
      { name: "scan_time", type: "float32", isComplex: false, isArray: false },
      { name: "range_min", type: "float32", isComplex: false, isArray: false },
      { name: "range_max", type: "float32", isComplex: false, isArray: false },
      { name: "ranges", type: "sensor_msgs/LaserEcho", isComplex: true, isArray: true },
      { name: "intensities", type: "sensor_msgs/LaserEcho", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/NavSatFix": {
    name: "sensor_msgs/NavSatFix",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "status", type: "sensor_msgs/NavSatStatus", isComplex: true, isArray: false },
      { name: "latitude", type: "float64", isComplex: false, isArray: false },
      { name: "longitude", type: "float64", isComplex: false, isArray: false },
      { name: "altitude", type: "float64", isComplex: false, isArray: false },
      {
        name: "position_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
      {
        name: "COVARIANCE_TYPE_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "COVARIANCE_TYPE_APPROXIMATED",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "COVARIANCE_TYPE_DIAGONAL_KNOWN",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      { name: "COVARIANCE_TYPE_KNOWN", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "position_covariance_type", type: "uint8", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/NavSatStatus": {
    name: "sensor_msgs/NavSatStatus",
    definitions: [
      { name: "STATUS_NO_FIX", type: "int8", isConstant: true, value: -1, valueText: "-1" },
      { name: "STATUS_FIX", type: "int8", isConstant: true, value: 0, valueText: "0" },
      { name: "STATUS_SBAS_FIX", type: "int8", isConstant: true, value: 1, valueText: "1" },
      { name: "STATUS_GBAS_FIX", type: "int8", isConstant: true, value: 2, valueText: "2" },
      { name: "status", type: "int8", isComplex: false, isArray: false },
      { name: "SERVICE_GPS", type: "uint16", isConstant: true, value: 1, valueText: "1" },
      { name: "SERVICE_GLONASS", type: "uint16", isConstant: true, value: 2, valueText: "2" },
      { name: "SERVICE_COMPASS", type: "uint16", isConstant: true, value: 4, valueText: "4" },
      { name: "SERVICE_GALILEO", type: "uint16", isConstant: true, value: 8, valueText: "8" },
      { name: "service", type: "uint16", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/PointCloud": {
    name: "sensor_msgs/PointCloud",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "points", type: "geometry_msgs/Point32", isComplex: true, isArray: true },
      { name: "channels", type: "sensor_msgs/ChannelFloat32", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/PointCloud2": {
    name: "sensor_msgs/PointCloud2",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "fields", type: "sensor_msgs/PointField", isComplex: true, isArray: true },
      { name: "is_bigendian", type: "bool", isComplex: false, isArray: false },
      { name: "point_step", type: "uint32", isComplex: false, isArray: false },
      { name: "row_step", type: "uint32", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
      { name: "is_dense", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/PointField": {
    name: "sensor_msgs/PointField",
    definitions: [
      { name: "INT8", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "UINT8", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "INT16", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "UINT16", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "INT32", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "UINT32", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      { name: "FLOAT32", type: "uint8", isConstant: true, value: 7, valueText: "7" },
      { name: "FLOAT64", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "offset", type: "uint32", isComplex: false, isArray: false },
      { name: "datatype", type: "uint8", isComplex: false, isArray: false },
      { name: "count", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Range": {
    name: "sensor_msgs/Range",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "ULTRASOUND", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "INFRARED", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "radiation_type", type: "uint8", isComplex: false, isArray: false },
      { name: "field_of_view", type: "float32", isComplex: false, isArray: false },
      { name: "min_range", type: "float32", isComplex: false, isArray: false },
      { name: "max_range", type: "float32", isComplex: false, isArray: false },
      { name: "range", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/RelativeHumidity": {
    name: "sensor_msgs/RelativeHumidity",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "relative_humidity", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Temperature": {
    name: "sensor_msgs/Temperature",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "temperature", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/TimeReference": {
    name: "sensor_msgs/TimeReference",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "time_ref", type: "time", isComplex: false, isArray: false },
      { name: "source", type: "string", isComplex: false, isArray: false },
    ],
  },
  "shape_msgs/Mesh": {
    name: "shape_msgs/Mesh",
    definitions: [
      { name: "triangles", type: "shape_msgs/MeshTriangle", isComplex: true, isArray: true },
      { name: "vertices", type: "geometry_msgs/Point", isComplex: true, isArray: true },
    ],
  },
  "shape_msgs/MeshTriangle": {
    name: "shape_msgs/MeshTriangle",
    definitions: [
      { name: "vertex_indices", type: "uint32", isComplex: false, isArray: true, arrayLength: 3 },
    ],
  },
  "shape_msgs/Plane": {
    name: "shape_msgs/Plane",
    definitions: [
      { name: "coef", type: "float64", isComplex: false, isArray: true, arrayLength: 4 },
    ],
  },
  "shape_msgs/SolidPrimitive": {
    name: "shape_msgs/SolidPrimitive",
    definitions: [
      { name: "BOX", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "SPHERE", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "CYLINDER", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "CONE", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "dimensions", type: "float64", isComplex: false, isArray: true, arrayUpperBound: 3 },
      { name: "BOX_X", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "BOX_Y", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "BOX_Z", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "SPHERE_RADIUS", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "CYLINDER_HEIGHT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "CYLINDER_RADIUS", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "CONE_HEIGHT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "CONE_RADIUS", type: "uint8", isConstant: true, value: 1, valueText: "1" },
    ],
  },
  "statistics_msgs/MetricsMessage": {
    name: "statistics_msgs/MetricsMessage",
    definitions: [
      { name: "measurement_source_name", type: "string", isComplex: false, isArray: false },
      { name: "metrics_source", type: "string", isComplex: false, isArray: false },
      { name: "unit", type: "string", isComplex: false, isArray: false },
      { name: "window_start", type: "time", isComplex: false, isArray: false },
      { name: "window_stop", type: "time", isComplex: false, isArray: false },
      {
        name: "statistics",
        type: "statistics_msgs/StatisticDataPoint",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "statistics_msgs/StatisticDataPoint": {
    name: "statistics_msgs/StatisticDataPoint",
    definitions: [
      { name: "data_type", type: "uint8", isComplex: false, isArray: false },
      { name: "data", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "statistics_msgs/StatisticDataType": {
    name: "statistics_msgs/StatisticDataType",
    definitions: [
      {
        name: "STATISTICS_DATA_TYPE_UNINITIALIZED",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "STATISTICS_DATA_TYPE_AVERAGE",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "STATISTICS_DATA_TYPE_MINIMUM",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "STATISTICS_DATA_TYPE_MAXIMUM",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "STATISTICS_DATA_TYPE_STDDEV",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "STATISTICS_DATA_TYPE_SAMPLE_COUNT",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
    ],
  },
  "std_msgs/Bool": {
    name: "std_msgs/Bool",
    definitions: [{ name: "data", type: "bool", isComplex: false, isArray: false }],
  },
  "std_msgs/Byte": {
    name: "std_msgs/Byte",
    definitions: [{ name: "data", type: "int8", isComplex: false, isArray: false }],
  },
  "std_msgs/ByteMultiArray": {
    name: "std_msgs/ByteMultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int8", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/MultiArrayLayout": {
    name: "std_msgs/MultiArrayLayout",
    definitions: [
      { name: "dim", type: "std_msgs/MultiArrayDimension", isComplex: true, isArray: true },
      { name: "data_offset", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "std_msgs/MultiArrayDimension": {
    name: "std_msgs/MultiArrayDimension",
    definitions: [
      { name: "label", type: "string", isComplex: false, isArray: false },
      { name: "size", type: "uint32", isComplex: false, isArray: false },
      { name: "stride", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "std_msgs/Char": {
    name: "std_msgs/Char",
    definitions: [{ name: "data", type: "uint8", isComplex: false, isArray: false }],
  },
  "std_msgs/ColorRGBA": {
    name: "std_msgs/ColorRGBA",
    definitions: [
      { name: "r", type: "float32", isComplex: false, isArray: false },
      { name: "g", type: "float32", isComplex: false, isArray: false },
      { name: "b", type: "float32", isComplex: false, isArray: false },
      { name: "a", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "std_msgs/Empty": { name: "std_msgs/Empty", definitions: [] },
  "std_msgs/Float32": {
    name: "std_msgs/Float32",
    definitions: [{ name: "data", type: "float32", isComplex: false, isArray: false }],
  },
  "std_msgs/Float32MultiArray": {
    name: "std_msgs/Float32MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "float32", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Float64": {
    name: "std_msgs/Float64",
    definitions: [{ name: "data", type: "float64", isComplex: false, isArray: false }],
  },
  "std_msgs/Float64MultiArray": {
    name: "std_msgs/Float64MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "float64", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int16": {
    name: "std_msgs/Int16",
    definitions: [{ name: "data", type: "int16", isComplex: false, isArray: false }],
  },
  "std_msgs/Int16MultiArray": {
    name: "std_msgs/Int16MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int16", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int32": {
    name: "std_msgs/Int32",
    definitions: [{ name: "data", type: "int32", isComplex: false, isArray: false }],
  },
  "std_msgs/Int32MultiArray": {
    name: "std_msgs/Int32MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int32", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int64": {
    name: "std_msgs/Int64",
    definitions: [{ name: "data", type: "int64", isComplex: false, isArray: false }],
  },
  "std_msgs/Int64MultiArray": {
    name: "std_msgs/Int64MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int64", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int8": {
    name: "std_msgs/Int8",
    definitions: [{ name: "data", type: "int8", isComplex: false, isArray: false }],
  },
  "std_msgs/Int8MultiArray": {
    name: "std_msgs/Int8MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int8", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/String": {
    name: "std_msgs/String",
    definitions: [{ name: "data", type: "string", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt16": {
    name: "std_msgs/UInt16",
    definitions: [{ name: "data", type: "uint16", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt16MultiArray": {
    name: "std_msgs/UInt16MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint16", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/UInt32": {
    name: "std_msgs/UInt32",
    definitions: [{ name: "data", type: "uint32", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt32MultiArray": {
    name: "std_msgs/UInt32MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint32", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/UInt64": {
    name: "std_msgs/UInt64",
    definitions: [{ name: "data", type: "uint64", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt64MultiArray": {
    name: "std_msgs/UInt64MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint64", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/UInt8": {
    name: "std_msgs/UInt8",
    definitions: [{ name: "data", type: "uint8", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt8MultiArray": {
    name: "std_msgs/UInt8MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "stereo_msgs/DisparityImage": {
    name: "stereo_msgs/DisparityImage",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "image", type: "sensor_msgs/Image", isComplex: true, isArray: false },
      { name: "f", type: "float32", isComplex: false, isArray: false },
      { name: "t", type: "float32", isComplex: false, isArray: false },
      {
        name: "valid_window",
        type: "sensor_msgs/RegionOfInterest",
        isComplex: true,
        isArray: false,
      },
      { name: "min_disparity", type: "float32", isComplex: false, isArray: false },
      { name: "max_disparity", type: "float32", isComplex: false, isArray: false },
      { name: "delta_d", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "test_msgs/Builtins": {
    name: "test_msgs/Builtins",
    definitions: [
      { name: "duration_value", type: "duration", isComplex: false, isArray: false },
      { name: "time_value", type: "time", isComplex: false, isArray: false },
    ],
  },
  "trajectory_msgs/JointTrajectory": {
    name: "trajectory_msgs/JointTrajectory",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "joint_names", type: "string", isComplex: false, isArray: true },
      {
        name: "points",
        type: "trajectory_msgs/JointTrajectoryPoint",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "trajectory_msgs/JointTrajectoryPoint": {
    name: "trajectory_msgs/JointTrajectoryPoint",
    definitions: [
      { name: "positions", type: "float64", isComplex: false, isArray: true },
      { name: "velocities", type: "float64", isComplex: false, isArray: true },
      { name: "accelerations", type: "float64", isComplex: false, isArray: true },
      { name: "effort", type: "float64", isComplex: false, isArray: true },
      { name: "time_from_start", type: "duration", isComplex: false, isArray: false },
    ],
  },
  "trajectory_msgs/MultiDOFJointTrajectory": {
    name: "trajectory_msgs/MultiDOFJointTrajectory",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "joint_names", type: "string", isComplex: false, isArray: true },
      {
        name: "points",
        type: "trajectory_msgs/MultiDOFJointTrajectoryPoint",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "trajectory_msgs/MultiDOFJointTrajectoryPoint": {
    name: "trajectory_msgs/MultiDOFJointTrajectoryPoint",
    definitions: [
      { name: "transforms", type: "geometry_msgs/Transform", isComplex: true, isArray: true },
      { name: "velocities", type: "geometry_msgs/Twist", isComplex: true, isArray: true },
      { name: "accelerations", type: "geometry_msgs/Twist", isComplex: true, isArray: true },
      { name: "time_from_start", type: "duration", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/ImageMarker": {
    name: "visualization_msgs/ImageMarker",
    definitions: [
      { name: "CIRCLE", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "LINE_STRIP", type: "int32", isConstant: true, value: 1, valueText: "1" },
      { name: "LINE_LIST", type: "int32", isConstant: true, value: 2, valueText: "2" },
      { name: "POLYGON", type: "int32", isConstant: true, value: 3, valueText: "3" },
      { name: "POINTS", type: "int32", isConstant: true, value: 4, valueText: "4" },
      { name: "ADD", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "REMOVE", type: "int32", isConstant: true, value: 1, valueText: "1" },
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "ns", type: "string", isComplex: false, isArray: false },
      { name: "id", type: "int32", isComplex: false, isArray: false },
      { name: "type", type: "int32", isComplex: false, isArray: false },
      { name: "action", type: "int32", isComplex: false, isArray: false },
      { name: "position", type: "geometry_msgs/Point", isComplex: true, isArray: false },
      { name: "scale", type: "float32", isComplex: false, isArray: false },
      { name: "outline_color", type: "std_msgs/ColorRGBA", isComplex: true, isArray: false },
      { name: "filled", type: "uint8", isComplex: false, isArray: false },
      { name: "fill_color", type: "std_msgs/ColorRGBA", isComplex: true, isArray: false },
      { name: "lifetime", type: "duration", isComplex: false, isArray: false },
      { name: "points", type: "geometry_msgs/Point", isComplex: true, isArray: true },
      { name: "outline_colors", type: "std_msgs/ColorRGBA", isComplex: true, isArray: true },
    ],
  },
  "visualization_msgs/InteractiveMarker": {
    name: "visualization_msgs/InteractiveMarker",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "description", type: "string", isComplex: false, isArray: false },
      { name: "scale", type: "float32", isComplex: false, isArray: false },
      {
        name: "menu_entries",
        type: "visualization_msgs/MenuEntry",
        isComplex: true,
        isArray: true,
      },
      {
        name: "controls",
        type: "visualization_msgs/InteractiveMarkerControl",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "visualization_msgs/MenuEntry": {
    name: "visualization_msgs/MenuEntry",
    definitions: [
      { name: "id", type: "uint32", isComplex: false, isArray: false },
      { name: "parent_id", type: "uint32", isComplex: false, isArray: false },
      { name: "title", type: "string", isComplex: false, isArray: false },
      { name: "command", type: "string", isComplex: false, isArray: false },
      { name: "FEEDBACK", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "ROSRUN", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "ROSLAUNCH", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "command_type", type: "uint8", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerControl": {
    name: "visualization_msgs/InteractiveMarkerControl",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "orientation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
      { name: "INHERIT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "FIXED", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "VIEW_FACING", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "orientation_mode", type: "uint8", isComplex: false, isArray: false },
      { name: "NONE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "MENU", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "BUTTON", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "MOVE_AXIS", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "MOVE_PLANE", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "ROTATE_AXIS", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "MOVE_ROTATE", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      { name: "MOVE_3D", type: "uint8", isConstant: true, value: 7, valueText: "7" },
      { name: "ROTATE_3D", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "MOVE_ROTATE_3D", type: "uint8", isConstant: true, value: 9, valueText: "9" },
      { name: "interaction_mode", type: "uint8", isComplex: false, isArray: false },
      { name: "always_visible", type: "bool", isComplex: false, isArray: false },
      { name: "markers", type: "visualization_msgs/Marker", isComplex: true, isArray: true },
      { name: "independent_marker_orientation", type: "bool", isComplex: false, isArray: false },
      { name: "description", type: "string", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/Marker": {
    name: "visualization_msgs/Marker",
    definitions: [
      { name: "ARROW", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "CUBE", type: "int32", isConstant: true, value: 1, valueText: "1" },
      { name: "SPHERE", type: "int32", isConstant: true, value: 2, valueText: "2" },
      { name: "CYLINDER", type: "int32", isConstant: true, value: 3, valueText: "3" },
      { name: "LINE_STRIP", type: "int32", isConstant: true, value: 4, valueText: "4" },
      { name: "LINE_LIST", type: "int32", isConstant: true, value: 5, valueText: "5" },
      { name: "CUBE_LIST", type: "int32", isConstant: true, value: 6, valueText: "6" },
      { name: "SPHERE_LIST", type: "int32", isConstant: true, value: 7, valueText: "7" },
      { name: "POINTS", type: "int32", isConstant: true, value: 8, valueText: "8" },
      { name: "TEXT_VIEW_FACING", type: "int32", isConstant: true, value: 9, valueText: "9" },
      { name: "MESH_RESOURCE", type: "int32", isConstant: true, value: 10, valueText: "10" },
      { name: "TRIANGLE_LIST", type: "int32", isConstant: true, value: 11, valueText: "11" },
      { name: "ADD", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "MODIFY", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "DELETE", type: "int32", isConstant: true, value: 2, valueText: "2" },
      { name: "DELETEALL", type: "int32", isConstant: true, value: 3, valueText: "3" },
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "ns", type: "string", isComplex: false, isArray: false },
      { name: "id", type: "int32", isComplex: false, isArray: false },
      { name: "type", type: "int32", isComplex: false, isArray: false },
      { name: "action", type: "int32", isComplex: false, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "scale", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "color", type: "std_msgs/ColorRGBA", isComplex: true, isArray: false },
      { name: "lifetime", type: "duration", isComplex: false, isArray: false },
      { name: "frame_locked", type: "bool", isComplex: false, isArray: false },
      { name: "points", type: "geometry_msgs/Point", isComplex: true, isArray: true },
      { name: "colors", type: "std_msgs/ColorRGBA", isComplex: true, isArray: true },
      { name: "text", type: "string", isComplex: false, isArray: false },
      { name: "mesh_resource", type: "string", isComplex: false, isArray: false },
      { name: "mesh_use_embedded_materials", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerFeedback": {
    name: "visualization_msgs/InteractiveMarkerFeedback",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "client_id", type: "string", isComplex: false, isArray: false },
      { name: "marker_name", type: "string", isComplex: false, isArray: false },
      { name: "control_name", type: "string", isComplex: false, isArray: false },
      { name: "KEEP_ALIVE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "POSE_UPDATE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "MENU_SELECT", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "BUTTON_CLICK", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "MOUSE_DOWN", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "MOUSE_UP", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "event_type", type: "uint8", isComplex: false, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "menu_entry_id", type: "uint32", isComplex: false, isArray: false },
      { name: "mouse_point", type: "geometry_msgs/Point", isComplex: true, isArray: false },
      { name: "mouse_point_valid", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerInit": {
    name: "visualization_msgs/InteractiveMarkerInit",
    definitions: [
      { name: "server_id", type: "string", isComplex: false, isArray: false },
      { name: "seq_num", type: "uint64", isComplex: false, isArray: false },
      {
        name: "markers",
        type: "visualization_msgs/InteractiveMarker",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "visualization_msgs/InteractiveMarkerPose": {
    name: "visualization_msgs/InteractiveMarkerPose",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerUpdate": {
    name: "visualization_msgs/InteractiveMarkerUpdate",
    definitions: [
      { name: "server_id", type: "string", isComplex: false, isArray: false },
      { name: "seq_num", type: "uint64", isComplex: false, isArray: false },
      { name: "KEEP_ALIVE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "UPDATE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      {
        name: "markers",
        type: "visualization_msgs/InteractiveMarker",
        isComplex: true,
        isArray: true,
      },
      {
        name: "poses",
        type: "visualization_msgs/InteractiveMarkerPose",
        isComplex: true,
        isArray: true,
      },
      { name: "erases", type: "string", isComplex: false, isArray: true },
    ],
  },
  "visualization_msgs/MarkerArray": {
    name: "visualization_msgs/MarkerArray",
    definitions: [
      { name: "markers", type: "visualization_msgs/Marker", isComplex: true, isArray: true },
    ],
  },
};
module.exports.ros2galactic = ros2galacticDefinitions;

const ros2humbleDefinitions = {
  "action_msgs/GoalInfo": {
    name: "action_msgs/GoalInfo",
    definitions: [
      { name: "goal_id", type: "unique_identifier_msgs/UUID", isComplex: true, isArray: false },
      { name: "stamp", type: "time", isComplex: false, isArray: false },
    ],
  },
  "unique_identifier_msgs/UUID": {
    name: "unique_identifier_msgs/UUID",
    definitions: [
      { name: "uuid", type: "uint8", isComplex: false, isArray: true, arrayLength: 16 },
    ],
  },
  "action_msgs/GoalStatus": {
    name: "action_msgs/GoalStatus",
    definitions: [
      { name: "STATUS_UNKNOWN", type: "int8", isConstant: true, value: 0, valueText: "0" },
      { name: "STATUS_ACCEPTED", type: "int8", isConstant: true, value: 1, valueText: "1" },
      { name: "STATUS_EXECUTING", type: "int8", isConstant: true, value: 2, valueText: "2" },
      { name: "STATUS_CANCELING", type: "int8", isConstant: true, value: 3, valueText: "3" },
      { name: "STATUS_SUCCEEDED", type: "int8", isConstant: true, value: 4, valueText: "4" },
      { name: "STATUS_CANCELED", type: "int8", isConstant: true, value: 5, valueText: "5" },
      { name: "STATUS_ABORTED", type: "int8", isConstant: true, value: 6, valueText: "6" },
      { name: "goal_info", type: "action_msgs/GoalInfo", isComplex: true, isArray: false },
      { name: "status", type: "int8", isComplex: false, isArray: false },
    ],
  },
  "action_msgs/GoalStatusArray": {
    name: "action_msgs/GoalStatusArray",
    definitions: [
      { name: "status_list", type: "action_msgs/GoalStatus", isComplex: true, isArray: true },
    ],
  },
  "actionlib_msgs/GoalID": {
    name: "actionlib_msgs/GoalID",
    definitions: [
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "id", type: "string", isComplex: false, isArray: false },
    ],
  },
  "actionlib_msgs/GoalStatus": {
    name: "actionlib_msgs/GoalStatus",
    definitions: [
      { name: "goal_id", type: "actionlib_msgs/GoalID", isComplex: true, isArray: false },
      { name: "status", type: "uint8", isComplex: false, isArray: false },
      { name: "PENDING", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "ACTIVE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "PREEMPTED", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "SUCCEEDED", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "ABORTED", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "REJECTED", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "PREEMPTING", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      { name: "RECALLING", type: "uint8", isConstant: true, value: 7, valueText: "7" },
      { name: "RECALLED", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "LOST", type: "uint8", isConstant: true, value: 9, valueText: "9" },
      { name: "text", type: "string", isComplex: false, isArray: false },
    ],
  },
  "actionlib_msgs/GoalStatusArray": {
    name: "actionlib_msgs/GoalStatusArray",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "status_list", type: "actionlib_msgs/GoalStatus", isComplex: true, isArray: true },
    ],
  },
  "std_msgs/Header": {
    name: "std_msgs/Header",
    definitions: [
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "frame_id", type: "string", isComplex: false, isArray: false },
    ],
  },
  "builtin_interfaces/Duration": {
    name: "builtin_interfaces/Duration",
    definitions: [
      { name: "sec", type: "int32", isComplex: false, isArray: false },
      { name: "nanosec", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "builtin_interfaces/Time": {
    name: "builtin_interfaces/Time",
    definitions: [
      { name: "sec", type: "int32", isComplex: false, isArray: false },
      { name: "nanosec", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "diagnostic_msgs/DiagnosticArray": {
    name: "diagnostic_msgs/DiagnosticArray",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "status", type: "diagnostic_msgs/DiagnosticStatus", isComplex: true, isArray: true },
    ],
  },
  "diagnostic_msgs/DiagnosticStatus": {
    name: "diagnostic_msgs/DiagnosticStatus",
    definitions: [
      { name: "OK", type: "int8", isConstant: true, value: 0, valueText: "0" },
      { name: "WARN", type: "int8", isConstant: true, value: 1, valueText: "1" },
      { name: "ERROR", type: "int8", isConstant: true, value: 2, valueText: "2" },
      { name: "STALE", type: "int8", isConstant: true, value: 3, valueText: "3" },
      { name: "level", type: "int8", isComplex: false, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "message", type: "string", isComplex: false, isArray: false },
      { name: "hardware_id", type: "string", isComplex: false, isArray: false },
      { name: "values", type: "diagnostic_msgs/KeyValue", isComplex: true, isArray: true },
    ],
  },
  "diagnostic_msgs/KeyValue": {
    name: "diagnostic_msgs/KeyValue",
    definitions: [
      { name: "key", type: "string", isComplex: false, isArray: false },
      { name: "value", type: "string", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/Accel": {
    name: "geometry_msgs/Accel",
    definitions: [
      { name: "linear", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "angular", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Vector3": {
    name: "geometry_msgs/Vector3",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false },
      { name: "y", type: "float64", isComplex: false, isArray: false },
      { name: "z", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/AccelStamped": {
    name: "geometry_msgs/AccelStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "accel", type: "geometry_msgs/Accel", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/AccelWithCovariance": {
    name: "geometry_msgs/AccelWithCovariance",
    definitions: [
      { name: "accel", type: "geometry_msgs/Accel", isComplex: true, isArray: false },
      { name: "covariance", type: "float64", isComplex: false, isArray: true, arrayLength: 36 },
    ],
  },
  "geometry_msgs/AccelWithCovarianceStamped": {
    name: "geometry_msgs/AccelWithCovarianceStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "accel", type: "geometry_msgs/AccelWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Inertia": {
    name: "geometry_msgs/Inertia",
    definitions: [
      { name: "m", type: "float64", isComplex: false, isArray: false },
      { name: "com", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "ixx", type: "float64", isComplex: false, isArray: false },
      { name: "ixy", type: "float64", isComplex: false, isArray: false },
      { name: "ixz", type: "float64", isComplex: false, isArray: false },
      { name: "iyy", type: "float64", isComplex: false, isArray: false },
      { name: "iyz", type: "float64", isComplex: false, isArray: false },
      { name: "izz", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/InertiaStamped": {
    name: "geometry_msgs/InertiaStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "inertia", type: "geometry_msgs/Inertia", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Point": {
    name: "geometry_msgs/Point",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false },
      { name: "y", type: "float64", isComplex: false, isArray: false },
      { name: "z", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/Point32": {
    name: "geometry_msgs/Point32",
    definitions: [
      { name: "x", type: "float32", isComplex: false, isArray: false },
      { name: "y", type: "float32", isComplex: false, isArray: false },
      { name: "z", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/PointStamped": {
    name: "geometry_msgs/PointStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "point", type: "geometry_msgs/Point", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Polygon": {
    name: "geometry_msgs/Polygon",
    definitions: [
      { name: "points", type: "geometry_msgs/Point32", isComplex: true, isArray: true },
    ],
  },
  "geometry_msgs/PolygonStamped": {
    name: "geometry_msgs/PolygonStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "polygon", type: "geometry_msgs/Polygon", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Pose": {
    name: "geometry_msgs/Pose",
    definitions: [
      { name: "position", type: "geometry_msgs/Point", isComplex: true, isArray: false },
      { name: "orientation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Quaternion": {
    name: "geometry_msgs/Quaternion",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false, defaultValue: 0 },
      { name: "y", type: "float64", isComplex: false, isArray: false, defaultValue: 0 },
      { name: "z", type: "float64", isComplex: false, isArray: false, defaultValue: 0 },
      { name: "w", type: "float64", isComplex: false, isArray: false, defaultValue: 1 },
    ],
  },
  "geometry_msgs/Pose2D": {
    name: "geometry_msgs/Pose2D",
    definitions: [
      { name: "x", type: "float64", isComplex: false, isArray: false },
      { name: "y", type: "float64", isComplex: false, isArray: false },
      { name: "theta", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "geometry_msgs/PoseArray": {
    name: "geometry_msgs/PoseArray",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "poses", type: "geometry_msgs/Pose", isComplex: true, isArray: true },
    ],
  },
  "geometry_msgs/PoseStamped": {
    name: "geometry_msgs/PoseStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/PoseWithCovariance": {
    name: "geometry_msgs/PoseWithCovariance",
    definitions: [
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "covariance", type: "float64", isComplex: false, isArray: true, arrayLength: 36 },
    ],
  },
  "geometry_msgs/PoseWithCovarianceStamped": {
    name: "geometry_msgs/PoseWithCovarianceStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/PoseWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/QuaternionStamped": {
    name: "geometry_msgs/QuaternionStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "quaternion", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Transform": {
    name: "geometry_msgs/Transform",
    definitions: [
      { name: "translation", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "rotation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/TransformStamped": {
    name: "geometry_msgs/TransformStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "child_frame_id", type: "string", isComplex: false, isArray: false },
      { name: "transform", type: "geometry_msgs/Transform", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Twist": {
    name: "geometry_msgs/Twist",
    definitions: [
      { name: "linear", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "angular", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/TwistStamped": {
    name: "geometry_msgs/TwistStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "twist", type: "geometry_msgs/Twist", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/TwistWithCovariance": {
    name: "geometry_msgs/TwistWithCovariance",
    definitions: [
      { name: "twist", type: "geometry_msgs/Twist", isComplex: true, isArray: false },
      { name: "covariance", type: "float64", isComplex: false, isArray: true, arrayLength: 36 },
    ],
  },
  "geometry_msgs/TwistWithCovarianceStamped": {
    name: "geometry_msgs/TwistWithCovarianceStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "twist", type: "geometry_msgs/TwistWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Vector3Stamped": {
    name: "geometry_msgs/Vector3Stamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "vector", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/Wrench": {
    name: "geometry_msgs/Wrench",
    definitions: [
      { name: "force", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "torque", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
    ],
  },
  "geometry_msgs/WrenchStamped": {
    name: "geometry_msgs/WrenchStamped",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "wrench", type: "geometry_msgs/Wrench", isComplex: true, isArray: false },
    ],
  },
  "lifecycle_msgs/State": {
    name: "lifecycle_msgs/State",
    definitions: [
      { name: "PRIMARY_STATE_UNKNOWN", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      {
        name: "PRIMARY_STATE_UNCONFIGURED",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      { name: "PRIMARY_STATE_INACTIVE", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "PRIMARY_STATE_ACTIVE", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      {
        name: "PRIMARY_STATE_FINALIZED",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "TRANSITION_STATE_CONFIGURING",
        type: "uint8",
        isConstant: true,
        value: 10,
        valueText: "10",
      },
      {
        name: "TRANSITION_STATE_CLEANINGUP",
        type: "uint8",
        isConstant: true,
        value: 11,
        valueText: "11",
      },
      {
        name: "TRANSITION_STATE_SHUTTINGDOWN",
        type: "uint8",
        isConstant: true,
        value: 12,
        valueText: "12",
      },
      {
        name: "TRANSITION_STATE_ACTIVATING",
        type: "uint8",
        isConstant: true,
        value: 13,
        valueText: "13",
      },
      {
        name: "TRANSITION_STATE_DEACTIVATING",
        type: "uint8",
        isConstant: true,
        value: 14,
        valueText: "14",
      },
      {
        name: "TRANSITION_STATE_ERRORPROCESSING",
        type: "uint8",
        isConstant: true,
        value: 15,
        valueText: "15",
      },
      { name: "id", type: "uint8", isComplex: false, isArray: false },
      { name: "label", type: "string", isComplex: false, isArray: false },
    ],
  },
  "lifecycle_msgs/Transition": {
    name: "lifecycle_msgs/Transition",
    definitions: [
      { name: "TRANSITION_CREATE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "TRANSITION_CONFIGURE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "TRANSITION_CLEANUP", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "TRANSITION_ACTIVATE", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "TRANSITION_DEACTIVATE", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      {
        name: "TRANSITION_UNCONFIGURED_SHUTDOWN",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        name: "TRANSITION_INACTIVE_SHUTDOWN",
        type: "uint8",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      {
        name: "TRANSITION_ACTIVE_SHUTDOWN",
        type: "uint8",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      { name: "TRANSITION_DESTROY", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      {
        name: "TRANSITION_ON_CONFIGURE_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 10,
        valueText: "10",
      },
      {
        name: "TRANSITION_ON_CONFIGURE_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 11,
        valueText: "11",
      },
      {
        name: "TRANSITION_ON_CONFIGURE_ERROR",
        type: "uint8",
        isConstant: true,
        value: 12,
        valueText: "12",
      },
      {
        name: "TRANSITION_ON_CLEANUP_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 20,
        valueText: "20",
      },
      {
        name: "TRANSITION_ON_CLEANUP_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 21,
        valueText: "21",
      },
      {
        name: "TRANSITION_ON_CLEANUP_ERROR",
        type: "uint8",
        isConstant: true,
        value: 22,
        valueText: "22",
      },
      {
        name: "TRANSITION_ON_ACTIVATE_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 30,
        valueText: "30",
      },
      {
        name: "TRANSITION_ON_ACTIVATE_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 31,
        valueText: "31",
      },
      {
        name: "TRANSITION_ON_ACTIVATE_ERROR",
        type: "uint8",
        isConstant: true,
        value: 32,
        valueText: "32",
      },
      {
        name: "TRANSITION_ON_DEACTIVATE_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 40,
        valueText: "40",
      },
      {
        name: "TRANSITION_ON_DEACTIVATE_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 41,
        valueText: "41",
      },
      {
        name: "TRANSITION_ON_DEACTIVATE_ERROR",
        type: "uint8",
        isConstant: true,
        value: 42,
        valueText: "42",
      },
      {
        name: "TRANSITION_ON_SHUTDOWN_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 50,
        valueText: "50",
      },
      {
        name: "TRANSITION_ON_SHUTDOWN_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 51,
        valueText: "51",
      },
      {
        name: "TRANSITION_ON_SHUTDOWN_ERROR",
        type: "uint8",
        isConstant: true,
        value: 52,
        valueText: "52",
      },
      {
        name: "TRANSITION_ON_ERROR_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 60,
        valueText: "60",
      },
      {
        name: "TRANSITION_ON_ERROR_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 61,
        valueText: "61",
      },
      {
        name: "TRANSITION_ON_ERROR_ERROR",
        type: "uint8",
        isConstant: true,
        value: 62,
        valueText: "62",
      },
      {
        name: "TRANSITION_CALLBACK_SUCCESS",
        type: "uint8",
        isConstant: true,
        value: 97,
        valueText: "97",
      },
      {
        name: "TRANSITION_CALLBACK_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 98,
        valueText: "98",
      },
      {
        name: "TRANSITION_CALLBACK_ERROR",
        type: "uint8",
        isConstant: true,
        value: 99,
        valueText: "99",
      },
      { name: "id", type: "uint8", isComplex: false, isArray: false },
      { name: "label", type: "string", isComplex: false, isArray: false },
    ],
  },
  "lifecycle_msgs/TransitionDescription": {
    name: "lifecycle_msgs/TransitionDescription",
    definitions: [
      { name: "transition", type: "lifecycle_msgs/Transition", isComplex: true, isArray: false },
      { name: "start_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
      { name: "goal_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
    ],
  },
  "lifecycle_msgs/TransitionEvent": {
    name: "lifecycle_msgs/TransitionEvent",
    definitions: [
      { name: "timestamp", type: "uint64", isComplex: false, isArray: false },
      { name: "transition", type: "lifecycle_msgs/Transition", isComplex: true, isArray: false },
      { name: "start_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
      { name: "goal_state", type: "lifecycle_msgs/State", isComplex: true, isArray: false },
    ],
  },
  "nav_msgs/GridCells": {
    name: "nav_msgs/GridCells",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "cell_width", type: "float32", isComplex: false, isArray: false },
      { name: "cell_height", type: "float32", isComplex: false, isArray: false },
      { name: "cells", type: "geometry_msgs/Point", isComplex: true, isArray: true },
    ],
  },
  "nav_msgs/MapMetaData": {
    name: "nav_msgs/MapMetaData",
    definitions: [
      { name: "map_load_time", type: "time", isComplex: false, isArray: false },
      { name: "resolution", type: "float32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "origin", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
    ],
  },
  "nav_msgs/OccupancyGrid": {
    name: "nav_msgs/OccupancyGrid",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "info", type: "nav_msgs/MapMetaData", isComplex: true, isArray: false },
      { name: "data", type: "int8", isComplex: false, isArray: true },
    ],
  },
  "nav_msgs/Odometry": {
    name: "nav_msgs/Odometry",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "child_frame_id", type: "string", isComplex: false, isArray: false },
      { name: "pose", type: "geometry_msgs/PoseWithCovariance", isComplex: true, isArray: false },
      { name: "twist", type: "geometry_msgs/TwistWithCovariance", isComplex: true, isArray: false },
    ],
  },
  "nav_msgs/Path": {
    name: "nav_msgs/Path",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "poses", type: "geometry_msgs/PoseStamped", isComplex: true, isArray: true },
    ],
  },
  "rcl_interfaces/FloatingPointRange": {
    name: "rcl_interfaces/FloatingPointRange",
    definitions: [
      { name: "from_value", type: "float64", isComplex: false, isArray: false },
      { name: "to_value", type: "float64", isComplex: false, isArray: false },
      { name: "step", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "rcl_interfaces/IntegerRange": {
    name: "rcl_interfaces/IntegerRange",
    definitions: [
      { name: "from_value", type: "int64", isComplex: false, isArray: false },
      { name: "to_value", type: "int64", isComplex: false, isArray: false },
      { name: "step", type: "uint64", isComplex: false, isArray: false },
    ],
  },
  "rcl_interfaces/ListParametersResult": {
    name: "rcl_interfaces/ListParametersResult",
    definitions: [
      { name: "names", type: "string", isComplex: false, isArray: true },
      { name: "prefixes", type: "string", isComplex: false, isArray: true },
    ],
  },
  "rcl_interfaces/Log": {
    name: "rcl_interfaces/Log",
    definitions: [
      { name: "DEBUG", type: "int8", isConstant: true, value: 10, valueText: "10" },
      { name: "INFO", type: "int8", isConstant: true, value: 20, valueText: "20" },
      { name: "WARN", type: "int8", isConstant: true, value: 30, valueText: "30" },
      { name: "ERROR", type: "int8", isConstant: true, value: 40, valueText: "40" },
      { name: "FATAL", type: "int8", isConstant: true, value: 50, valueText: "50" },
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "level", type: "uint8", isComplex: false, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "msg", type: "string", isComplex: false, isArray: false },
      { name: "file", type: "string", isComplex: false, isArray: false },
      { name: "function", type: "string", isComplex: false, isArray: false },
      { name: "line", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "rcl_interfaces/Parameter": {
    name: "rcl_interfaces/Parameter",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "value", type: "rcl_interfaces/ParameterValue", isComplex: true, isArray: false },
    ],
  },
  "rcl_interfaces/ParameterValue": {
    name: "rcl_interfaces/ParameterValue",
    definitions: [
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "bool_value", type: "bool", isComplex: false, isArray: false },
      { name: "integer_value", type: "int64", isComplex: false, isArray: false },
      { name: "double_value", type: "float64", isComplex: false, isArray: false },
      { name: "string_value", type: "string", isComplex: false, isArray: false },
      { name: "byte_array_value", type: "int8", isComplex: false, isArray: true },
      { name: "bool_array_value", type: "bool", isComplex: false, isArray: true },
      { name: "integer_array_value", type: "int64", isComplex: false, isArray: true },
      { name: "double_array_value", type: "float64", isComplex: false, isArray: true },
      { name: "string_array_value", type: "string", isComplex: false, isArray: true },
    ],
  },
  "rcl_interfaces/ParameterDescriptor": {
    name: "rcl_interfaces/ParameterDescriptor",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "description", type: "string", isComplex: false, isArray: false },
      { name: "additional_constraints", type: "string", isComplex: false, isArray: false },
      { name: "read_only", type: "bool", isComplex: false, isArray: false, defaultValue: false },
      {
        name: "dynamic_typing",
        type: "bool",
        isComplex: false,
        isArray: false,
        defaultValue: false,
      },
      {
        name: "floating_point_range",
        type: "rcl_interfaces/FloatingPointRange",
        isComplex: true,
        isArray: true,
        arrayUpperBound: 1,
      },
      {
        name: "integer_range",
        type: "rcl_interfaces/IntegerRange",
        isComplex: true,
        isArray: true,
        arrayUpperBound: 1,
      },
    ],
  },
  "rcl_interfaces/ParameterEvent": {
    name: "rcl_interfaces/ParameterEvent",
    definitions: [
      { name: "stamp", type: "time", isComplex: false, isArray: false },
      { name: "node", type: "string", isComplex: false, isArray: false },
      { name: "new_parameters", type: "rcl_interfaces/Parameter", isComplex: true, isArray: true },
      {
        name: "changed_parameters",
        type: "rcl_interfaces/Parameter",
        isComplex: true,
        isArray: true,
      },
      {
        name: "deleted_parameters",
        type: "rcl_interfaces/Parameter",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "rcl_interfaces/ParameterEventDescriptors": {
    name: "rcl_interfaces/ParameterEventDescriptors",
    definitions: [
      {
        name: "new_parameters",
        type: "rcl_interfaces/ParameterDescriptor",
        isComplex: true,
        isArray: true,
      },
      {
        name: "changed_parameters",
        type: "rcl_interfaces/ParameterDescriptor",
        isComplex: true,
        isArray: true,
      },
      {
        name: "deleted_parameters",
        type: "rcl_interfaces/ParameterDescriptor",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "rcl_interfaces/ParameterType": {
    name: "rcl_interfaces/ParameterType",
    definitions: [
      { name: "PARAMETER_NOT_SET", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "PARAMETER_BOOL", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "PARAMETER_INTEGER", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "PARAMETER_DOUBLE", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "PARAMETER_STRING", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "PARAMETER_BYTE_ARRAY", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "PARAMETER_BOOL_ARRAY", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      {
        name: "PARAMETER_INTEGER_ARRAY",
        type: "uint8",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      { name: "PARAMETER_DOUBLE_ARRAY", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "PARAMETER_STRING_ARRAY", type: "uint8", isConstant: true, value: 9, valueText: "9" },
    ],
  },
  "rcl_interfaces/SetParametersResult": {
    name: "rcl_interfaces/SetParametersResult",
    definitions: [
      { name: "successful", type: "bool", isComplex: false, isArray: false },
      { name: "reason", type: "string", isComplex: false, isArray: false },
    ],
  },
  "rosgraph_msgs/Clock": {
    name: "rosgraph_msgs/Clock",
    definitions: [{ name: "clock", type: "time", isComplex: false, isArray: false }],
  },
  "sensor_msgs/BatteryState": {
    name: "sensor_msgs/BatteryState",
    definitions: [
      {
        name: "POWER_SUPPLY_STATUS_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "POWER_SUPPLY_STATUS_CHARGING",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "POWER_SUPPLY_STATUS_DISCHARGING",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "POWER_SUPPLY_STATUS_NOT_CHARGING",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "POWER_SUPPLY_STATUS_FULL",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "POWER_SUPPLY_HEALTH_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "POWER_SUPPLY_HEALTH_GOOD",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "POWER_SUPPLY_HEALTH_OVERHEAT",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "POWER_SUPPLY_HEALTH_DEAD",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "POWER_SUPPLY_HEALTH_OVERVOLTAGE",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "POWER_SUPPLY_HEALTH_UNSPEC_FAILURE",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        name: "POWER_SUPPLY_HEALTH_COLD",
        type: "uint8",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      {
        name: "POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE",
        type: "uint8",
        isConstant: true,
        value: 7,
        valueText: "7",
      },
      {
        name: "POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE",
        type: "uint8",
        isConstant: true,
        value: 8,
        valueText: "8",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_NIMH",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LION",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LIPO",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LIFE",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_NICD",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
      {
        name: "POWER_SUPPLY_TECHNOLOGY_LIMN",
        type: "uint8",
        isConstant: true,
        value: 6,
        valueText: "6",
      },
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "voltage", type: "float32", isComplex: false, isArray: false },
      { name: "temperature", type: "float32", isComplex: false, isArray: false },
      { name: "current", type: "float32", isComplex: false, isArray: false },
      { name: "charge", type: "float32", isComplex: false, isArray: false },
      { name: "capacity", type: "float32", isComplex: false, isArray: false },
      { name: "design_capacity", type: "float32", isComplex: false, isArray: false },
      { name: "percentage", type: "float32", isComplex: false, isArray: false },
      { name: "power_supply_status", type: "uint8", isComplex: false, isArray: false },
      { name: "power_supply_health", type: "uint8", isComplex: false, isArray: false },
      { name: "power_supply_technology", type: "uint8", isComplex: false, isArray: false },
      { name: "present", type: "bool", isComplex: false, isArray: false },
      { name: "cell_voltage", type: "float32", isComplex: false, isArray: true },
      { name: "cell_temperature", type: "float32", isComplex: false, isArray: true },
      { name: "location", type: "string", isComplex: false, isArray: false },
      { name: "serial_number", type: "string", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/CameraInfo": {
    name: "sensor_msgs/CameraInfo",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "distortion_model", type: "string", isComplex: false, isArray: false },
      { name: "d", type: "float64", isComplex: false, isArray: true },
      { name: "k", type: "float64", isComplex: false, isArray: true, arrayLength: 9 },
      { name: "r", type: "float64", isComplex: false, isArray: true, arrayLength: 9 },
      { name: "p", type: "float64", isComplex: false, isArray: true, arrayLength: 12 },
      { name: "binning_x", type: "uint32", isComplex: false, isArray: false },
      { name: "binning_y", type: "uint32", isComplex: false, isArray: false },
      { name: "roi", type: "sensor_msgs/RegionOfInterest", isComplex: true, isArray: false },
    ],
  },
  "sensor_msgs/RegionOfInterest": {
    name: "sensor_msgs/RegionOfInterest",
    definitions: [
      { name: "x_offset", type: "uint32", isComplex: false, isArray: false },
      { name: "y_offset", type: "uint32", isComplex: false, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "do_rectify", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/ChannelFloat32": {
    name: "sensor_msgs/ChannelFloat32",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "values", type: "float32", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/CompressedImage": {
    name: "sensor_msgs/CompressedImage",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "format", type: "string", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/FluidPressure": {
    name: "sensor_msgs/FluidPressure",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "fluid_pressure", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Illuminance": {
    name: "sensor_msgs/Illuminance",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "illuminance", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Image": {
    name: "sensor_msgs/Image",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "encoding", type: "string", isComplex: false, isArray: false },
      { name: "is_bigendian", type: "uint8", isComplex: false, isArray: false },
      { name: "step", type: "uint32", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/Imu": {
    name: "sensor_msgs/Imu",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "orientation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
      {
        name: "orientation_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
      { name: "angular_velocity", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      {
        name: "angular_velocity_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
      {
        name: "linear_acceleration",
        type: "geometry_msgs/Vector3",
        isComplex: true,
        isArray: false,
      },
      {
        name: "linear_acceleration_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
    ],
  },
  "sensor_msgs/JointState": {
    name: "sensor_msgs/JointState",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: true },
      { name: "position", type: "float64", isComplex: false, isArray: true },
      { name: "velocity", type: "float64", isComplex: false, isArray: true },
      { name: "effort", type: "float64", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/Joy": {
    name: "sensor_msgs/Joy",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "axes", type: "float32", isComplex: false, isArray: true },
      { name: "buttons", type: "int32", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/JoyFeedback": {
    name: "sensor_msgs/JoyFeedback",
    definitions: [
      { name: "TYPE_LED", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "TYPE_RUMBLE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "TYPE_BUZZER", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "id", type: "uint8", isComplex: false, isArray: false },
      { name: "intensity", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/JoyFeedbackArray": {
    name: "sensor_msgs/JoyFeedbackArray",
    definitions: [
      { name: "array", type: "sensor_msgs/JoyFeedback", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/LaserEcho": {
    name: "sensor_msgs/LaserEcho",
    definitions: [{ name: "echoes", type: "float32", isComplex: false, isArray: true }],
  },
  "sensor_msgs/LaserScan": {
    name: "sensor_msgs/LaserScan",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "angle_min", type: "float32", isComplex: false, isArray: false },
      { name: "angle_max", type: "float32", isComplex: false, isArray: false },
      { name: "angle_increment", type: "float32", isComplex: false, isArray: false },
      { name: "time_increment", type: "float32", isComplex: false, isArray: false },
      { name: "scan_time", type: "float32", isComplex: false, isArray: false },
      { name: "range_min", type: "float32", isComplex: false, isArray: false },
      { name: "range_max", type: "float32", isComplex: false, isArray: false },
      { name: "ranges", type: "float32", isComplex: false, isArray: true },
      { name: "intensities", type: "float32", isComplex: false, isArray: true },
    ],
  },
  "sensor_msgs/MagneticField": {
    name: "sensor_msgs/MagneticField",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "magnetic_field", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      {
        name: "magnetic_field_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
    ],
  },
  "sensor_msgs/MultiDOFJointState": {
    name: "sensor_msgs/MultiDOFJointState",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "joint_names", type: "string", isComplex: false, isArray: true },
      { name: "transforms", type: "geometry_msgs/Transform", isComplex: true, isArray: true },
      { name: "twist", type: "geometry_msgs/Twist", isComplex: true, isArray: true },
      { name: "wrench", type: "geometry_msgs/Wrench", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/MultiEchoLaserScan": {
    name: "sensor_msgs/MultiEchoLaserScan",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "angle_min", type: "float32", isComplex: false, isArray: false },
      { name: "angle_max", type: "float32", isComplex: false, isArray: false },
      { name: "angle_increment", type: "float32", isComplex: false, isArray: false },
      { name: "time_increment", type: "float32", isComplex: false, isArray: false },
      { name: "scan_time", type: "float32", isComplex: false, isArray: false },
      { name: "range_min", type: "float32", isComplex: false, isArray: false },
      { name: "range_max", type: "float32", isComplex: false, isArray: false },
      { name: "ranges", type: "sensor_msgs/LaserEcho", isComplex: true, isArray: true },
      { name: "intensities", type: "sensor_msgs/LaserEcho", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/NavSatFix": {
    name: "sensor_msgs/NavSatFix",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "status", type: "sensor_msgs/NavSatStatus", isComplex: true, isArray: false },
      { name: "latitude", type: "float64", isComplex: false, isArray: false },
      { name: "longitude", type: "float64", isComplex: false, isArray: false },
      { name: "altitude", type: "float64", isComplex: false, isArray: false },
      {
        name: "position_covariance",
        type: "float64",
        isComplex: false,
        isArray: true,
        arrayLength: 9,
      },
      {
        name: "COVARIANCE_TYPE_UNKNOWN",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "COVARIANCE_TYPE_APPROXIMATED",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "COVARIANCE_TYPE_DIAGONAL_KNOWN",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      { name: "COVARIANCE_TYPE_KNOWN", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "position_covariance_type", type: "uint8", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/NavSatStatus": {
    name: "sensor_msgs/NavSatStatus",
    definitions: [
      { name: "STATUS_NO_FIX", type: "int8", isConstant: true, value: -1, valueText: "-1" },
      { name: "STATUS_FIX", type: "int8", isConstant: true, value: 0, valueText: "0" },
      { name: "STATUS_SBAS_FIX", type: "int8", isConstant: true, value: 1, valueText: "1" },
      { name: "STATUS_GBAS_FIX", type: "int8", isConstant: true, value: 2, valueText: "2" },
      { name: "status", type: "int8", isComplex: false, isArray: false },
      { name: "SERVICE_GPS", type: "uint16", isConstant: true, value: 1, valueText: "1" },
      { name: "SERVICE_GLONASS", type: "uint16", isConstant: true, value: 2, valueText: "2" },
      { name: "SERVICE_COMPASS", type: "uint16", isConstant: true, value: 4, valueText: "4" },
      { name: "SERVICE_GALILEO", type: "uint16", isConstant: true, value: 8, valueText: "8" },
      { name: "service", type: "uint16", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/PointCloud": {
    name: "sensor_msgs/PointCloud",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "points", type: "geometry_msgs/Point32", isComplex: true, isArray: true },
      { name: "channels", type: "sensor_msgs/ChannelFloat32", isComplex: true, isArray: true },
    ],
  },
  "sensor_msgs/PointCloud2": {
    name: "sensor_msgs/PointCloud2",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "height", type: "uint32", isComplex: false, isArray: false },
      { name: "width", type: "uint32", isComplex: false, isArray: false },
      { name: "fields", type: "sensor_msgs/PointField", isComplex: true, isArray: true },
      { name: "is_bigendian", type: "bool", isComplex: false, isArray: false },
      { name: "point_step", type: "uint32", isComplex: false, isArray: false },
      { name: "row_step", type: "uint32", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
      { name: "is_dense", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/PointField": {
    name: "sensor_msgs/PointField",
    definitions: [
      { name: "INT8", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "UINT8", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "INT16", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "UINT16", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "INT32", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "UINT32", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      { name: "FLOAT32", type: "uint8", isConstant: true, value: 7, valueText: "7" },
      { name: "FLOAT64", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "offset", type: "uint32", isComplex: false, isArray: false },
      { name: "datatype", type: "uint8", isComplex: false, isArray: false },
      { name: "count", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Range": {
    name: "sensor_msgs/Range",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "ULTRASOUND", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "INFRARED", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "radiation_type", type: "uint8", isComplex: false, isArray: false },
      { name: "field_of_view", type: "float32", isComplex: false, isArray: false },
      { name: "min_range", type: "float32", isComplex: false, isArray: false },
      { name: "max_range", type: "float32", isComplex: false, isArray: false },
      { name: "range", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/RelativeHumidity": {
    name: "sensor_msgs/RelativeHumidity",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "relative_humidity", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/Temperature": {
    name: "sensor_msgs/Temperature",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "temperature", type: "float64", isComplex: false, isArray: false },
      { name: "variance", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "sensor_msgs/TimeReference": {
    name: "sensor_msgs/TimeReference",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "time_ref", type: "time", isComplex: false, isArray: false },
      { name: "source", type: "string", isComplex: false, isArray: false },
    ],
  },
  "shape_msgs/Mesh": {
    name: "shape_msgs/Mesh",
    definitions: [
      { name: "triangles", type: "shape_msgs/MeshTriangle", isComplex: true, isArray: true },
      { name: "vertices", type: "geometry_msgs/Point", isComplex: true, isArray: true },
    ],
  },
  "shape_msgs/MeshTriangle": {
    name: "shape_msgs/MeshTriangle",
    definitions: [
      { name: "vertex_indices", type: "uint32", isComplex: false, isArray: true, arrayLength: 3 },
    ],
  },
  "shape_msgs/Plane": {
    name: "shape_msgs/Plane",
    definitions: [
      { name: "coef", type: "float64", isComplex: false, isArray: true, arrayLength: 4 },
    ],
  },
  "shape_msgs/SolidPrimitive": {
    name: "shape_msgs/SolidPrimitive",
    definitions: [
      { name: "BOX", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "SPHERE", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "CYLINDER", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "CONE", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "PRISM", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      { name: "dimensions", type: "float64", isComplex: false, isArray: true, arrayUpperBound: 3 },
      { name: "BOX_X", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "BOX_Y", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "BOX_Z", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "SPHERE_RADIUS", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "CYLINDER_HEIGHT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "CYLINDER_RADIUS", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "CONE_HEIGHT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "CONE_RADIUS", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "PRISM_HEIGHT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "polygon", type: "geometry_msgs/Polygon", isComplex: true, isArray: false },
    ],
  },
  "statistics_msgs/MetricsMessage": {
    name: "statistics_msgs/MetricsMessage",
    definitions: [
      { name: "measurement_source_name", type: "string", isComplex: false, isArray: false },
      { name: "metrics_source", type: "string", isComplex: false, isArray: false },
      { name: "unit", type: "string", isComplex: false, isArray: false },
      { name: "window_start", type: "time", isComplex: false, isArray: false },
      { name: "window_stop", type: "time", isComplex: false, isArray: false },
      {
        name: "statistics",
        type: "statistics_msgs/StatisticDataPoint",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "statistics_msgs/StatisticDataPoint": {
    name: "statistics_msgs/StatisticDataPoint",
    definitions: [
      { name: "data_type", type: "uint8", isComplex: false, isArray: false },
      { name: "data", type: "float64", isComplex: false, isArray: false },
    ],
  },
  "statistics_msgs/StatisticDataType": {
    name: "statistics_msgs/StatisticDataType",
    definitions: [
      {
        name: "STATISTICS_DATA_TYPE_UNINITIALIZED",
        type: "uint8",
        isConstant: true,
        value: 0,
        valueText: "0",
      },
      {
        name: "STATISTICS_DATA_TYPE_AVERAGE",
        type: "uint8",
        isConstant: true,
        value: 1,
        valueText: "1",
      },
      {
        name: "STATISTICS_DATA_TYPE_MINIMUM",
        type: "uint8",
        isConstant: true,
        value: 2,
        valueText: "2",
      },
      {
        name: "STATISTICS_DATA_TYPE_MAXIMUM",
        type: "uint8",
        isConstant: true,
        value: 3,
        valueText: "3",
      },
      {
        name: "STATISTICS_DATA_TYPE_STDDEV",
        type: "uint8",
        isConstant: true,
        value: 4,
        valueText: "4",
      },
      {
        name: "STATISTICS_DATA_TYPE_SAMPLE_COUNT",
        type: "uint8",
        isConstant: true,
        value: 5,
        valueText: "5",
      },
    ],
  },
  "std_msgs/Bool": {
    name: "std_msgs/Bool",
    definitions: [{ name: "data", type: "bool", isComplex: false, isArray: false }],
  },
  "std_msgs/Byte": {
    name: "std_msgs/Byte",
    definitions: [{ name: "data", type: "int8", isComplex: false, isArray: false }],
  },
  "std_msgs/ByteMultiArray": {
    name: "std_msgs/ByteMultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int8", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/MultiArrayLayout": {
    name: "std_msgs/MultiArrayLayout",
    definitions: [
      { name: "dim", type: "std_msgs/MultiArrayDimension", isComplex: true, isArray: true },
      { name: "data_offset", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "std_msgs/MultiArrayDimension": {
    name: "std_msgs/MultiArrayDimension",
    definitions: [
      { name: "label", type: "string", isComplex: false, isArray: false },
      { name: "size", type: "uint32", isComplex: false, isArray: false },
      { name: "stride", type: "uint32", isComplex: false, isArray: false },
    ],
  },
  "std_msgs/Char": {
    name: "std_msgs/Char",
    definitions: [{ name: "data", type: "uint8", isComplex: false, isArray: false }],
  },
  "std_msgs/ColorRGBA": {
    name: "std_msgs/ColorRGBA",
    definitions: [
      { name: "r", type: "float32", isComplex: false, isArray: false },
      { name: "g", type: "float32", isComplex: false, isArray: false },
      { name: "b", type: "float32", isComplex: false, isArray: false },
      { name: "a", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "std_msgs/Empty": { name: "std_msgs/Empty", definitions: [] },
  "std_msgs/Float32": {
    name: "std_msgs/Float32",
    definitions: [{ name: "data", type: "float32", isComplex: false, isArray: false }],
  },
  "std_msgs/Float32MultiArray": {
    name: "std_msgs/Float32MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "float32", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Float64": {
    name: "std_msgs/Float64",
    definitions: [{ name: "data", type: "float64", isComplex: false, isArray: false }],
  },
  "std_msgs/Float64MultiArray": {
    name: "std_msgs/Float64MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "float64", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int16": {
    name: "std_msgs/Int16",
    definitions: [{ name: "data", type: "int16", isComplex: false, isArray: false }],
  },
  "std_msgs/Int16MultiArray": {
    name: "std_msgs/Int16MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int16", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int32": {
    name: "std_msgs/Int32",
    definitions: [{ name: "data", type: "int32", isComplex: false, isArray: false }],
  },
  "std_msgs/Int32MultiArray": {
    name: "std_msgs/Int32MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int32", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int64": {
    name: "std_msgs/Int64",
    definitions: [{ name: "data", type: "int64", isComplex: false, isArray: false }],
  },
  "std_msgs/Int64MultiArray": {
    name: "std_msgs/Int64MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int64", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/Int8": {
    name: "std_msgs/Int8",
    definitions: [{ name: "data", type: "int8", isComplex: false, isArray: false }],
  },
  "std_msgs/Int8MultiArray": {
    name: "std_msgs/Int8MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "int8", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/String": {
    name: "std_msgs/String",
    definitions: [{ name: "data", type: "string", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt16": {
    name: "std_msgs/UInt16",
    definitions: [{ name: "data", type: "uint16", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt16MultiArray": {
    name: "std_msgs/UInt16MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint16", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/UInt32": {
    name: "std_msgs/UInt32",
    definitions: [{ name: "data", type: "uint32", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt32MultiArray": {
    name: "std_msgs/UInt32MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint32", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/UInt64": {
    name: "std_msgs/UInt64",
    definitions: [{ name: "data", type: "uint64", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt64MultiArray": {
    name: "std_msgs/UInt64MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint64", isComplex: false, isArray: true },
    ],
  },
  "std_msgs/UInt8": {
    name: "std_msgs/UInt8",
    definitions: [{ name: "data", type: "uint8", isComplex: false, isArray: false }],
  },
  "std_msgs/UInt8MultiArray": {
    name: "std_msgs/UInt8MultiArray",
    definitions: [
      { name: "layout", type: "std_msgs/MultiArrayLayout", isComplex: true, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "stereo_msgs/DisparityImage": {
    name: "stereo_msgs/DisparityImage",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "image", type: "sensor_msgs/Image", isComplex: true, isArray: false },
      { name: "f", type: "float32", isComplex: false, isArray: false },
      { name: "t", type: "float32", isComplex: false, isArray: false },
      {
        name: "valid_window",
        type: "sensor_msgs/RegionOfInterest",
        isComplex: true,
        isArray: false,
      },
      { name: "min_disparity", type: "float32", isComplex: false, isArray: false },
      { name: "max_disparity", type: "float32", isComplex: false, isArray: false },
      { name: "delta_d", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "test_msgs/Builtins": {
    name: "test_msgs/Builtins",
    definitions: [
      { name: "duration_value", type: "duration", isComplex: false, isArray: false },
      { name: "time_value", type: "time", isComplex: false, isArray: false },
    ],
  },
  "trajectory_msgs/JointTrajectory": {
    name: "trajectory_msgs/JointTrajectory",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "joint_names", type: "string", isComplex: false, isArray: true },
      {
        name: "points",
        type: "trajectory_msgs/JointTrajectoryPoint",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "trajectory_msgs/JointTrajectoryPoint": {
    name: "trajectory_msgs/JointTrajectoryPoint",
    definitions: [
      { name: "positions", type: "float64", isComplex: false, isArray: true },
      { name: "velocities", type: "float64", isComplex: false, isArray: true },
      { name: "accelerations", type: "float64", isComplex: false, isArray: true },
      { name: "effort", type: "float64", isComplex: false, isArray: true },
      { name: "time_from_start", type: "duration", isComplex: false, isArray: false },
    ],
  },
  "trajectory_msgs/MultiDOFJointTrajectory": {
    name: "trajectory_msgs/MultiDOFJointTrajectory",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "joint_names", type: "string", isComplex: false, isArray: true },
      {
        name: "points",
        type: "trajectory_msgs/MultiDOFJointTrajectoryPoint",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "trajectory_msgs/MultiDOFJointTrajectoryPoint": {
    name: "trajectory_msgs/MultiDOFJointTrajectoryPoint",
    definitions: [
      { name: "transforms", type: "geometry_msgs/Transform", isComplex: true, isArray: true },
      { name: "velocities", type: "geometry_msgs/Twist", isComplex: true, isArray: true },
      { name: "accelerations", type: "geometry_msgs/Twist", isComplex: true, isArray: true },
      { name: "time_from_start", type: "duration", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/ImageMarker": {
    name: "visualization_msgs/ImageMarker",
    definitions: [
      { name: "CIRCLE", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "LINE_STRIP", type: "int32", isConstant: true, value: 1, valueText: "1" },
      { name: "LINE_LIST", type: "int32", isConstant: true, value: 2, valueText: "2" },
      { name: "POLYGON", type: "int32", isConstant: true, value: 3, valueText: "3" },
      { name: "POINTS", type: "int32", isConstant: true, value: 4, valueText: "4" },
      { name: "ADD", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "REMOVE", type: "int32", isConstant: true, value: 1, valueText: "1" },
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "ns", type: "string", isComplex: false, isArray: false },
      { name: "id", type: "int32", isComplex: false, isArray: false },
      { name: "type", type: "int32", isComplex: false, isArray: false },
      { name: "action", type: "int32", isComplex: false, isArray: false },
      { name: "position", type: "geometry_msgs/Point", isComplex: true, isArray: false },
      { name: "scale", type: "float32", isComplex: false, isArray: false },
      { name: "outline_color", type: "std_msgs/ColorRGBA", isComplex: true, isArray: false },
      { name: "filled", type: "uint8", isComplex: false, isArray: false },
      { name: "fill_color", type: "std_msgs/ColorRGBA", isComplex: true, isArray: false },
      { name: "lifetime", type: "duration", isComplex: false, isArray: false },
      { name: "points", type: "geometry_msgs/Point", isComplex: true, isArray: true },
      { name: "outline_colors", type: "std_msgs/ColorRGBA", isComplex: true, isArray: true },
    ],
  },
  "visualization_msgs/InteractiveMarker": {
    name: "visualization_msgs/InteractiveMarker",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "description", type: "string", isComplex: false, isArray: false },
      { name: "scale", type: "float32", isComplex: false, isArray: false },
      {
        name: "menu_entries",
        type: "visualization_msgs/MenuEntry",
        isComplex: true,
        isArray: true,
      },
      {
        name: "controls",
        type: "visualization_msgs/InteractiveMarkerControl",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "visualization_msgs/MenuEntry": {
    name: "visualization_msgs/MenuEntry",
    definitions: [
      { name: "id", type: "uint32", isComplex: false, isArray: false },
      { name: "parent_id", type: "uint32", isComplex: false, isArray: false },
      { name: "title", type: "string", isComplex: false, isArray: false },
      { name: "command", type: "string", isComplex: false, isArray: false },
      { name: "FEEDBACK", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "ROSRUN", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "ROSLAUNCH", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "command_type", type: "uint8", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerControl": {
    name: "visualization_msgs/InteractiveMarkerControl",
    definitions: [
      { name: "name", type: "string", isComplex: false, isArray: false },
      { name: "orientation", type: "geometry_msgs/Quaternion", isComplex: true, isArray: false },
      { name: "INHERIT", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "FIXED", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "VIEW_FACING", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "orientation_mode", type: "uint8", isComplex: false, isArray: false },
      { name: "NONE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "MENU", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "BUTTON", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "MOVE_AXIS", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "MOVE_PLANE", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "ROTATE_AXIS", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "MOVE_ROTATE", type: "uint8", isConstant: true, value: 6, valueText: "6" },
      { name: "MOVE_3D", type: "uint8", isConstant: true, value: 7, valueText: "7" },
      { name: "ROTATE_3D", type: "uint8", isConstant: true, value: 8, valueText: "8" },
      { name: "MOVE_ROTATE_3D", type: "uint8", isConstant: true, value: 9, valueText: "9" },
      { name: "interaction_mode", type: "uint8", isComplex: false, isArray: false },
      { name: "always_visible", type: "bool", isComplex: false, isArray: false },
      { name: "markers", type: "visualization_msgs/Marker", isComplex: true, isArray: true },
      { name: "independent_marker_orientation", type: "bool", isComplex: false, isArray: false },
      { name: "description", type: "string", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/Marker": {
    name: "visualization_msgs/Marker",
    definitions: [
      { name: "ARROW", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "CUBE", type: "int32", isConstant: true, value: 1, valueText: "1" },
      { name: "SPHERE", type: "int32", isConstant: true, value: 2, valueText: "2" },
      { name: "CYLINDER", type: "int32", isConstant: true, value: 3, valueText: "3" },
      { name: "LINE_STRIP", type: "int32", isConstant: true, value: 4, valueText: "4" },
      { name: "LINE_LIST", type: "int32", isConstant: true, value: 5, valueText: "5" },
      { name: "CUBE_LIST", type: "int32", isConstant: true, value: 6, valueText: "6" },
      { name: "SPHERE_LIST", type: "int32", isConstant: true, value: 7, valueText: "7" },
      { name: "POINTS", type: "int32", isConstant: true, value: 8, valueText: "8" },
      { name: "TEXT_VIEW_FACING", type: "int32", isConstant: true, value: 9, valueText: "9" },
      { name: "MESH_RESOURCE", type: "int32", isConstant: true, value: 10, valueText: "10" },
      { name: "TRIANGLE_LIST", type: "int32", isConstant: true, value: 11, valueText: "11" },
      { name: "ADD", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "MODIFY", type: "int32", isConstant: true, value: 0, valueText: "0" },
      { name: "DELETE", type: "int32", isConstant: true, value: 2, valueText: "2" },
      { name: "DELETEALL", type: "int32", isConstant: true, value: 3, valueText: "3" },
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "ns", type: "string", isComplex: false, isArray: false },
      { name: "id", type: "int32", isComplex: false, isArray: false },
      { name: "type", type: "int32", isComplex: false, isArray: false },
      { name: "action", type: "int32", isComplex: false, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "scale", type: "geometry_msgs/Vector3", isComplex: true, isArray: false },
      { name: "color", type: "std_msgs/ColorRGBA", isComplex: true, isArray: false },
      { name: "lifetime", type: "duration", isComplex: false, isArray: false },
      { name: "frame_locked", type: "bool", isComplex: false, isArray: false },
      { name: "points", type: "geometry_msgs/Point", isComplex: true, isArray: true },
      { name: "colors", type: "std_msgs/ColorRGBA", isComplex: true, isArray: true },
      { name: "texture_resource", type: "string", isComplex: false, isArray: false },
      { name: "texture", type: "sensor_msgs/CompressedImage", isComplex: true, isArray: false },
      {
        name: "uv_coordinates",
        type: "visualization_msgs/UVCoordinate",
        isComplex: true,
        isArray: true,
      },
      { name: "text", type: "string", isComplex: false, isArray: false },
      { name: "mesh_resource", type: "string", isComplex: false, isArray: false },
      { name: "mesh_file", type: "visualization_msgs/MeshFile", isComplex: true, isArray: false },
      { name: "mesh_use_embedded_materials", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/UVCoordinate": {
    name: "visualization_msgs/UVCoordinate",
    definitions: [
      { name: "u", type: "float32", isComplex: false, isArray: false },
      { name: "v", type: "float32", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/MeshFile": {
    name: "visualization_msgs/MeshFile",
    definitions: [
      { name: "filename", type: "string", isComplex: false, isArray: false },
      { name: "data", type: "uint8", isComplex: false, isArray: true },
    ],
  },
  "visualization_msgs/InteractiveMarkerFeedback": {
    name: "visualization_msgs/InteractiveMarkerFeedback",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "client_id", type: "string", isComplex: false, isArray: false },
      { name: "marker_name", type: "string", isComplex: false, isArray: false },
      { name: "control_name", type: "string", isComplex: false, isArray: false },
      { name: "KEEP_ALIVE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "POSE_UPDATE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "MENU_SELECT", type: "uint8", isConstant: true, value: 2, valueText: "2" },
      { name: "BUTTON_CLICK", type: "uint8", isConstant: true, value: 3, valueText: "3" },
      { name: "MOUSE_DOWN", type: "uint8", isConstant: true, value: 4, valueText: "4" },
      { name: "MOUSE_UP", type: "uint8", isConstant: true, value: 5, valueText: "5" },
      { name: "event_type", type: "uint8", isComplex: false, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "menu_entry_id", type: "uint32", isComplex: false, isArray: false },
      { name: "mouse_point", type: "geometry_msgs/Point", isComplex: true, isArray: false },
      { name: "mouse_point_valid", type: "bool", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerInit": {
    name: "visualization_msgs/InteractiveMarkerInit",
    definitions: [
      { name: "server_id", type: "string", isComplex: false, isArray: false },
      { name: "seq_num", type: "uint64", isComplex: false, isArray: false },
      {
        name: "markers",
        type: "visualization_msgs/InteractiveMarker",
        isComplex: true,
        isArray: true,
      },
    ],
  },
  "visualization_msgs/InteractiveMarkerPose": {
    name: "visualization_msgs/InteractiveMarkerPose",
    definitions: [
      { name: "header", type: "std_msgs/Header", isComplex: true, isArray: false },
      { name: "pose", type: "geometry_msgs/Pose", isComplex: true, isArray: false },
      { name: "name", type: "string", isComplex: false, isArray: false },
    ],
  },
  "visualization_msgs/InteractiveMarkerUpdate": {
    name: "visualization_msgs/InteractiveMarkerUpdate",
    definitions: [
      { name: "server_id", type: "string", isComplex: false, isArray: false },
      { name: "seq_num", type: "uint64", isComplex: false, isArray: false },
      { name: "KEEP_ALIVE", type: "uint8", isConstant: true, value: 0, valueText: "0" },
      { name: "UPDATE", type: "uint8", isConstant: true, value: 1, valueText: "1" },
      { name: "type", type: "uint8", isComplex: false, isArray: false },
      {
        name: "markers",
        type: "visualization_msgs/InteractiveMarker",
        isComplex: true,
        isArray: true,
      },
      {
        name: "poses",
        type: "visualization_msgs/InteractiveMarkerPose",
        isComplex: true,
        isArray: true,
      },
      { name: "erases", type: "string", isComplex: false, isArray: true },
    ],
  },
  "visualization_msgs/MarkerArray": {
    name: "visualization_msgs/MarkerArray",
    definitions: [
      { name: "markers", type: "visualization_msgs/Marker", isComplex: true, isArray: true },
    ],
  },
};
module.exports.ros2humble = ros2humbleDefinitions;
